<template>
  <b-modal
    centered
    :size="selecting ? 'lg' : 'xl'"
    ref="modal"
    hide-header
    :hide-footer="listing"
    :no-close-on-backdrop="!listing"
    :no-close-on-esc="!listing"
    @hide="close"
    style="z-index: 100 !important"
  >
    <AudioRecordingModal ref="audio-modal" />
    <AdditionalInstructionModal ref="instruction-modal" />
    <EvaluationMetricModal ref="rubric-modal" />
    <MultipleAudioRecorder ref="multi-audio-modal" />
    <TextManagerModal ref="text-manager" />

    <b-modal ref="pond-modal" hide-footer hide-header centered>
      <FilePond
        ref="pond"
        class="p-2 m-2"
        label-idle="Arrastra tus archivos acá o haz clic para navegar"
        :allow-multiple="false"
        accepted-file-types="image/jpeg, image/png, image/svg+xml"
        :files="pondObject && pondObject.image ? [pondObject.image] : []"
      />
      <b-row class="text-right">
        <b-col offset="5">
          <b-button pill variant="danger" class="m-1" @click="closePond">
            <v-icon name="times" /> Cancelar</b-button
          >
          <b-button
            pill
            variant="primary"
            class="my-1 ml-1 mr-2"
            @click="associateImage"
          >
            <v-icon name="save" /> Guardar</b-button
          >
        </b-col>
      </b-row>
    </b-modal>
    <b-modal ref="multiple-images-modal" hide-footer hide-header centered size="lg">
      <div class="p-3">
        <h6 class="mb-3">Subir múltiples imágenes para pregunta abierta</h6>
        <FilePond
          ref="multiplePond"
          class="p-2 m-2"
          label-idle="Arrastra tus imágenes acá o haz clic para navegar"
          :allow-multiple="true"
          accepted-file-types="image/jpeg, image/png, image/svg+xml"
          :files="question.set_of_images ? question.set_of_images.map(img => ({ source: img })) : []"
        />
        <div v-if="question.set_of_images && question.set_of_images.length > 0" class="mt-3">
          <h6>Imágenes cargadas:</h6>
          <div class="d-flex flex-wrap">
            <div v-for="(image, index) in question.set_of_images" :key="index" class="m-2 position-relative">
              <b-img 
                :src="image" 
                alt="Imagen" 
                width="100" 
                height="100" 
                class="border rounded"
                @click="openModalImage(image)"
              />
              <b-button 
                variant="danger" 
                size="sm" 
                class="position-absolute" 
                style="top: -5px; right: -5px;"
                @click="removeImageFromSet(index)"
              >
                <v-icon name="times" />
              </b-button>
            </div>
          </div>
        </div>
      </div>
      <b-row class="text-right p-3">
        <b-col offset="5">
          <b-button pill variant="danger" class="m-1" @click="closeMultipleImagesModal">
            <v-icon name="times" /> Cancelar</b-button
          >
          <b-button
            pill
            variant="primary"
            class="my-1 ml-1 mr-2"
            @click="associateMultipleImages"
          >
            <v-icon name="save" /> Guardar</b-button
          >
        </b-col>
      </b-row>
    </b-modal>
    <b-modal ref="image-modal" hide-footer hide-header centered>
      <div class="modal-image">
        <b-img :src="modalImage" alt="modal-image" width="320px"></b-img>
      </div>
    </b-modal>
    <b-modal
      ref="warning-discard-modal"
      centered
      hide-footer
      hide-header
      rounded-0
    >
      <div class="m-2">
        <b-row>
          <b-col class="text-center">
            <p>Al salir sin guardar se perderán todos los cambios</p>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="text-center">
            <b-button class="ml-0" pill variant="danger" @click="close">
              <b>Salir</b>
            </b-button>
          </b-col>
          <b-col class="text-center">
            <b-button
              class="ml-0"
              pill
              variant="primary"
              @click="
                $refs['warning-discard-modal'].hide();
                save();
              "
            >
              <v-icon name="save" /> Guardar
            </b-button>
          </b-col>
          <!-- <b-col class="text-center">
                <b-button class="ml-0" pill variant="danger" @click="$refs['warning-discard-modal'].hide()">
                <b> Cancelar</b>
                </b-button>
            </b-col> -->
        </b-row>
      </div>
    </b-modal>
    <warning-empty-modal
      warning="Tu pregunta está vacía"
      message="Debes escribir un enunciado para poder guardar"
      ref="warning-empty-modal"
    />
    <RelatedMaterialsSidebar
      @open-material="openRelatedMaterial"
      :objectID="question.id"
      ref="related-materials-sidebar"
    />
    <div v-if="creating || editing" class="creating">
      <!-- PRINCIPAL MODAL OPTIONS -->
      <tags-component
        :preSelectedSubtags="question.subtags"
        :preSelectedTag="question.tag"
        :preselected="preselectedHT"
        :grade="grade"
        :subject="subject"
        @set-tag="setTag"
        @set-subtags="setSubtag"
      />
      <b-form-row class="w-100 px-3 pt-2">
        <b-col cols="12">
          <label for="pedagogical-description" class="font-weight-bold">
            <v-icon name="info-circle" scale="0.9" />
            ¿Qué mide esta pregunta?
          </label>
          <b-form-textarea
            id="pedagogical-description"
            v-model="question.pedagogical_description"
            class="w-100"
            name="pedagogical_description"
            placeholder="Describe específicamente qué habilidad o concepto evalúa esta pregunta..."
            rows="3"
            max-rows="6"
          />
          <small class="text-muted">
            Opcional: Agrega una descripción detallada de lo que esta pregunta busca evaluar.
          </small>
        </b-col>
      </b-form-row>
      <b-form-row class="w-100 p-3">
        <b-col cols="7">
          <b-form-textarea
            v-model="question.question"
            class="w-100"
            name="question"
            placeholder="Ingresa tu pregunta"
            size="lg"
          />
        </b-col>

        <b-col cols="1" @click="manageRecording(question)">
          <MicrophoneIcon viewbox="0 0 100 100" width="55" height="55" />
        </b-col>
        <b-col cols="1" @click="attachImage(question)">
          <ClipIcon viewbox="0 0 100 100" width="55" height="55" />
        </b-col>
        <b-col cols="1" @click="openRubric(question)">
          <RubricIcon viewbox="0 0 100 100" width="55" height="55" />
        </b-col>
        <b-col cols="1" v-if="question.kind === 1" @click="attachMultipleImages(question)">
          <b-button
            class="btn-circle-lg"
            pill
            size="lg"
            variant="info"
            title="Subir múltiples imágenes"
          >
            <v-icon name="images" />
          </b-button>
        </b-col>

        <b-col
          cols="1"
          class="formula text-center"
          @click="question.formulas.push('x=1+1')"
        >
          <FormulaIcon
            class="formula-on"
            viewbox="0 0 100 100"
            width="55"
            height="55"
            :on="true"
          />
          <FormulaIcon
            class="formula-off"
            viewbox="0 0 100 100"
            width="55"
            height="55"
            :on="false"
          />
        </b-col>
        <b-col cols="1">
          <b-button
            class="btn-circle-lg"
            pill
            size="lg"
            variant="primary"
            @click="openInstruction(question)"
          >
            <v-icon name="folder-plus" />
          </b-button>
        </b-col>
      </b-form-row>

      <!-- <b-form-row class="px-3 pb-2">
                    <b-col>
                    <b-badge class="mr-2" v-for="(subtag, tIndex) in question.subtags" :key="tIndex" variant="primary">{{subtag.name}}</b-badge>
                    </b-col>
            </b-form-row> -->
      <div v-if="question.kind !== 6 && question.kind !== 7 && question.kind !== 8 && question.kind !== 9 && question.kind !== 10">
        <b-form-row
          v-if="question.formulas && question.formulas.length > 0"
          class="px-3"
        >
          Fórmulas
        </b-form-row>
        <b-form-row
          v-for="(formula, findex) in question.formulas"
          :key="findex"
          class="px-3"
        >
          <b-col>
            <math-field
              @blur="
                (event) => {
                  change(findex, event.target.value);
                }
              "
              :id="'formula-' + findex"
              :key="'formula-' + formula"
              :ref="'formula-' + findex"
              virtual-keyboard-mode="onfocus"
              virtual-keyboard-container="modal"
              style="height: 50px; font-size: 20pt; z-index: 1041"
            >
              {{ formula }}
            </math-field>
          </b-col>
          <b-col cols="1">
            <div @click="deleteFormula(findex)">
              <TrashIcon viewbox="0 0 100 100" width="35" height="35" />
            </div>
          </b-col>
        </b-form-row>
      </div>

      <b-row
        class="mx-3 my-1 px-0 py-2 rounded border audio-section"
        v-if="question.audio"
      >
        <b-col cols="2">
          <div class="ml-0 pt-1" size="md">
            <audio
              ref="player-question"
              :src="question.audio"
              autoplay
              @ended="nowPlaying = ''"
              @play="nowPlaying = 'question'"
            ></audio>
            <b-img
              @click="togglePlayer('question')"
              width="30px"
              class="ml-1 mr-1"
              alt="audio-img"
              :src="nowPlaying === 'question' ? repeatIcon : listenIcon"
              style="cursor: pointer"
            />
          </div>
        </b-col>
        <b-col class="pt-2 h6 text-muted text-left" sm="6" md="7">
          Audio adjunto
        </b-col>
        <b-col
          class="d-flex justify-content-center align-content-center border-left"
          sm="4"
          md="3"
        >
          <b-button
            class="mx-1"
            size="md"
            variant="outline-danger"
            @click="deleteAudio(question)"
          >
            <v-icon name="trash-alt" />
          </b-button>
        </b-col>
      </b-row>

      <b-row
        class="mx-3 my-1 px-0 py-2 image-section rounded border"
        v-if="question.image"
      >
        <b-col cols="10" class="border-right">
          <b-img
            :src="question.image_url"
            v-if="question.image.file"
            width="200"
          />
          <b-img
            :src="question.image"
            v-if="!question.image.file"
            width="200"
          />
          <b-form-row class="mt-2">
            <b-col cols="6">
              <b-form-group label="Ancho (puntos PDF)" label-cols="6" label-class="mx-2">
                <b-form-input
                  v-model.number="question.image_width"
                  type="number"
                  min="0"
                  size="sm"
                  placeholder="Ej: 140"
                ></b-form-input>
                <small class="text-muted">Ancho de la imagen en el PDF (en puntos)</small>
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group label="Alto (puntos PDF)" label-cols="6" label-class="mx-2">
                <b-form-input
                  v-model.number="question.image_height"
                  type="number"
                  min="0"
                  size="sm"
                  placeholder="Ej: 140"
                ></b-form-input>
                <small class="text-muted">Alto de la imagen en el PDF (en puntos)</small>
              </b-form-group>
            </b-col>
          </b-form-row>
        </b-col>
        <b-col
          cols="2"
          class="d-flex justify-content-center align-content-center"
        >
          <b-button
            class="mx-1"
            size="md"
            variant="outline-danger"
            @click="question.image = null"
          >
            <v-icon name="trash-alt" />
          </b-button>
        </b-col>
      </b-row>

      <!-- <b-form-row class="px-3 mx-1">
                <b-form-group label="Puntaje" label-cols="3">
                    <b-input type="number" min="1" v-model="question.score" size="sm"/>
                </b-form-group>
            </b-form-row> -->
      <b-form-row class="px-3">
        <b-form-checkbox v-model="question.show_rubric"> Mostrar rubrica </b-form-checkbox>
      </b-form-row>
      <b-form-row class="px-3"> Elige un tipo de respuesta: </b-form-row>
      <div class="w-100 p-3 scrollable-radio-group">
        <b-form-radio-group
          v-model="question.kind"
          :options="kinds"
          button-variant="outline-warning"
          buttons
        ></b-form-radio-group>
      </div>
      <div v-if="question.kind === 0" class="px-3 py-2">

      </div>
      <!-- ALTERNATIVAS -->
      <b-form-row class="w-100 px-3">
        <b-col
          cols="3"
          offset="9"
          v-if="question.kind === 0 && question.alternatives.length > 0"
          class="text-center"
          style="font-size: 10pt"
        >
          Alternativa <br />
          correcta
        </b-col>
      </b-form-row>
      <b-form-row
        v-for="(alternative, altIndex) of question.alternatives"
        v-if="question.kind === 0"
        :key="`${altIndex}`"
        class="w-100 px-3 my-1 border-bottom py-1 align-items-center"
      >
        <b-col cols="1" class="text-center">
          <table>
            <tr>
              <th class="py-0 vertical-align-middle">
                <v-icon
                  :name="altIndex === 0 ? 'arrow-up-off' : 'arrow-up-on'"
                  @click="moveElementUp(question.alternatives, altIndex)"
                  style="cursor: pointer"
                  scale="0.5"
                  class="text-info mt-2"
                />
              </th>
            </tr>
            <tr>
              <th>
                <v-icon
                  :name="
                    altIndex === question.alternatives.length - 1
                      ? 'arrow-down-off'
                      : 'arrow-down-on'
                  "
                  @click="moveElementDown(question.alternatives, altIndex)"
                  style="cursor: pointer"
                  scale="0.5"
                  class="text-info mb-2"
                />
              </th>
            </tr>
          </table>
        </b-col>
        <!-- <b-col cols="2" class="text-center" style="font-size:10pt;">
                    <label :for="`alt-${altIndex}`">Alternativa {{altIndex+1}}:</label>
                </b-col> -->
        <b-col cols="6" class="text-center" style="font-size: 10pt">
          <b-input
            v-model="alternative.text"
            class="w-100"
            v-if="!alternative.is_formula"
            :id="`alt-${altIndex}`"
            name="question"
            type="text"
            placeholder="Ingresa la alternativa"
            size="sm"
          />
          <math-field
            @blur="
              (event) => {
                question.alternatives[altIndex].text = event.target.value;
              }
            "
            v-else
            id="formula"
            virtual-keyboard-mode="manual"
            style="height: 50px; font-size: 20pt"
          >
            {{ alternative.text }}
          </math-field>
        </b-col>
        <b-col
          cols="1"
          class="text-center"
          @click="manageRecording(alternative)"
        >
          <MicrophoneIcon viewbox="0 0 100 100" width="35" height="35" />
        </b-col>
        <b-col cols="1" class="text-center" @click="attachImage(alternative)">
          <ClipIcon viewbox="0 0 100 100" width="35" height="35" />
        </b-col>
        <b-col
          cols="1"
          class="formula text-center"
          @click="alternative.is_formula = !alternative.is_formula"
        >
          <FormulaIcon
            class="formula-on"
            viewbox="0 0 100 100"
            width="35"
            height="35"
            :on="true"
          />
          <FormulaIcon
            class="formula-off"
            viewbox="0 0 100 100"
            width="35"
            height="35"
            :on="false"
          />
        </b-col>
        <b-col cols="1" class="text-center">
          <b-form-checkbox v-model="alternative.is_correct" />
        </b-col>
        <b-col
          cols="1"
          class="border-left text-center"
          @click="question.alternatives.splice(altIndex, 1)"
        >
          <TrashIcon viewbox="0 0 100 100" width="35" height="35" />
        </b-col>
        <b-form-row class="px-3" v-if="alternative.audio">
          <div class="mx-2 h6 text-muted">
            <v-icon name="paperclip" />
            {{ alternative.audio ? "audio.mp3" : "" }}
            <b-button
              class="ml-1 btn-circle"
              pill
              size="sm"
              variant="danger"
              @click="deleteAudio(alternative)"
            >
              <v-icon name="trash-alt" />
            </b-button>
          </div>
        </b-form-row>

        <b-form-row class="px-3" v-if="alternative.image">
          <div class="mx-2 h6 text-muted">
            <v-icon name="paperclip" />
            {{
              alternative.image
                ? alternative.image.filename
                  ? `${alternative.image.filename}`
                  : alternative.image.substring(
                      alternative.image.lastIndexOf("/") + 1
                    )
                : ""
            }}
            <b-button
              class="ml-1 btn-circle"
              pill
              size="sm"
              variant="danger"
              @click="alternative.image = null"
            >
              <v-icon name="trash-alt" />
            </b-button>
          </div>
        </b-form-row>
      </b-form-row>
      <b-form-row
        v-if="question.kind === 0"
        class="w-100 px-3 py-2 text-left"
        style="cursor: pointer"
      >
        <div class="text-muted">
          <p
            class="h6 mx-2"
            @click="question.alternatives.push(getEmptyAlternative())"
          >
            Clic acá para agregar una alternativa
            <v-icon name="plus-circle" scale="1.2" />
          </p>
        </div>
      </b-form-row>
      <!-- DESARROLLO -->
      <b-form-row v-else-if="question.kind === 1" class="px-3">
        <b-col>
        <div class="mx-2">
          <h6>El estudiante debe completar con:</h6>
          <b-radio-group
            v-model="question.response_type"
            :options="response_types"
            class="mx-4"
            stacked
          ></b-radio-group>
        </div>
        </b-col>
        <b-col>
          <b-form-row>
            <h6>Respuesta esperada:</h6>
          </b-form-row>
          <b-form-row>
            <b-col>
              <b-textarea
                v-model="question.expected_response"
                class="w-100"
                size="sm"
                rows="6"
              ></b-textarea>
            </b-col>
          </b-form-row>
        </b-col>
      </b-form-row>
      <b-form-row v-if="question.kind === 1" class="px-3">
        <b-col cols="12">
          <div class="mx-2">
            <b-form-group>
              <b-form-checkbox
                v-model="question.show_response_box"
                switch
              >
                Mostrar cajas de respuesta en el PDF
              </b-form-checkbox>
            </b-form-group>
            <div v-if="question.show_response_box" class="mt-3">
              <b-row>
                <b-col cols="6">
                  <b-form-group label="Número de párrafos (cajas)">
                    <b-form-input
                      v-model.number="question.response_paragraphs"
                      type="number"
                      min="1"
                      max="10"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col cols="6">
                  <b-form-group label="Número de líneas por párrafo">
                    <b-form-input
                      v-model.number="question.response_rows"
                      type="number"
                      min="1"
                      max="20"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
            </div>
          </div>
        </b-col>
      </b-form-row>
      <!-- DICTADO -->
      <div v-else-if="question.kind === 2" class="px-3">
        <b-form-row>
          <b-form-group
            label="Ingresa la cantidad de elementos a dictar (máx. 20)"
            label-cols="8"
            label-class="mx-2"
          >
            <b-form-input
              type="number"
              min="0"
              max="20"
              v-model="question.dictation"
              size="sm"
            ></b-form-input>
          </b-form-group>
        </b-form-row>
        <b-row align-h="start">
          <b-button
            pill
            variant="primary"
            size="sm"
            class="mx-3"
            @click="openMultirecordModal(question, question.dictation)"
          >
            <v-icon name="microphone" /><b>
              Grabar {{ question.dictation }} audio{{
                question.dictation > 1 ? "s" : ""
              }}</b
            >
          </b-button>
          <div
            v-if="
              question.dictation_audios && question.dictation_audios.length > 0
            "
            class="my-1"
          >
            Ya has grabado {{ question.dictation_audios.length }} audios
          </div>
        </b-row>
      </div>
      <!-- ORDENAMIENTO -->
      <b-form-row v-else-if="question.kind === 3" class="px-3">
        <b-col cols="12">
          <!-- Correct answers (ordered) display -->
          <div class="px-2 text-left mb-2">
            <h6>Respuestas correctas (en orden):</h6>
            <small class="text-muted">
              Las opciones marcadas como correctas aparecerán aquí en el orden en que fueron seleccionadas.
              Puedes reordenarlas con las flechas. En la sección de abajo, ordena cómo aparecerán todas las opciones al estudiante.
            </small>
          </div>

          <div v-if="orderingCorrectOptions && orderingCorrectOptions.length > 0">
            <b-row
              class="mx-1 align-items-center mb-2 border rounded p-2"
              v-for="(item, pos) in orderingCorrectOptions"
              :key="`ordering-correct-${item.index}`"
              no-gutters
            >
              <b-col cols="1" class="text-center pt-2">
                <span class="badge badge-primary">{{ pos + 1 }}°</span>
              </b-col>
              <b-col cols="2" class="text-center">
                <table>
                  <tr>
                    <th class="py-0 vertical-align-middle">
                      <v-icon
                        name="arrow-up-on"
                        @click="moveCorrectPositionUp(item.index, pos)"
                        :class="{ 'text-muted': pos === 0, 'text-info': pos > 0 }"
                        style="cursor: pointer"
                        scale="0.5"
                        class="mt-2"
                      />
                    </th>
                  </tr>
                  <tr>
                    <th>
                      <v-icon
                        name="arrow-down-on"
                        @click="moveCorrectPositionDown(item.index, pos)"
                        :class="{ 'text-muted': pos === orderingCorrectOptions.length - 1, 'text-info': pos < orderingCorrectOptions.length - 1 }"
                        style="cursor: pointer"
                        scale="0.5"
                        class="mb-2"
                      />
                    </th>
                  </tr>
                </table>
              </b-col>
              <b-col cols="7" class="px-2">
                <div v-if="item.option">
                  <span v-if="!item.option.is_formula">
                    {{ item.option.text || `Opción ${item.index + 1}` }}
                  </span>
                  <math-field
                    v-else
                    virtual-keyboard-mode="manual"
                    style="height: 40px; font-size: 16pt"
                    readonly
                  >
                    {{ item.option.text || `Opción ${item.index + 1}` }}
                  </math-field>
                </div>
                <div v-else class="text-muted">
                  Opción {{ item.index + 1 }} (no disponible)
                </div>
              </b-col>
              <b-col cols="2" class="text-right pr-3">
                <b-button
                  variant="danger"
                  size="sm"
                  @click="removeCorrectPosition(item.index)"
                >
                  <v-icon name="trash-alt" />
                </b-button>
              </b-col>
            </b-row>
          </div>
          <div v-else class="px-2 text-muted mb-3">
            <small>No hay respuestas correctas seleccionadas. Marca las opciones como correctas en la sección de abajo.</small>
          </div>

          <hr />

          <div class="px-2 text-left">
            <h6>Opciones (ordena con las flechas, el orden se guarda):</h6>
          </div>
          
          <!-- Single array of options with reordering (appearance order) -->
          <b-row
            class="mx-1 align-items-center mb-3"
            v-for="(option, oind) of question.options"
            :key="`ordering-opt-${oind}`"
            no-gutters
          >
            <b-col cols="12" class="border rounded p-2 mb-2">
              <b-row class="align-items-center">
                <b-col cols="1" class="text-center">
                  <table>
                    <tr>
                      <th class="py-0 vertical-align-middle">
                        <v-icon
                          name="arrow-up-on"
                          @click="moveOrderingOptionUp(oind)"
                          :class="{ 'text-muted': oind === 0, 'text-info': oind > 0 }"
                          style="cursor: pointer"
                          scale="0.5"
                          class="mt-2"
                        />
                      </th>
                    </tr>
                    <tr>
                      <th>
                        <v-icon
                          name="arrow-down-on"
                          @click="moveOrderingOptionDown(oind)"
                          :class="{ 'text-muted': oind === question.options.length - 1, 'text-info': oind < question.options.length - 1 }"
                          style="cursor: pointer"
                          scale="0.5"
                          class="mb-2"
                        />
                      </th>
                    </tr>
                  </table>
                </b-col>
                <b-col cols="10">
                  <b-input
                    v-if="!option.is_formula"
                    class="d-inline"
                    size="sm"
                    v-model="option.text"
                    :placeholder="`Opción ${oind + 1}`"
                  ></b-input>
                  <math-field
                    @blur="
                      (event) => {
                        option.text = event.target.value;
                      }
                    "
                    v-else
                    id="formula"
                    virtual-keyboard-mode="manual"
                    style="height: 50px; font-size: 20pt"
                  >
                    {{ option.text }}
                  </math-field>
                </b-col>
                <b-col class="pl-1">
                  <b-dropdown
                    size="sm"
                    toggle-class="rounded-circle custom-dots-button"
                    no-caret
                  >
                    <template #button-content>
                      <ThreeDotsIcon
                        viewbox="-35 10 100 120"
                        width="12"
                        height="18"
                      />
                    </template>
                    <b-dropdown-item href="#" @click="manageRecording(option)">
                      Agregar audio <v-icon name="microphone" scale="1" />
                    </b-dropdown-item>
                    <b-dropdown-item href="#" @click="attachImage(option)">
                      Agregar imagen <v-icon name="paperclip" scale="1" />
                    </b-dropdown-item>
                  </b-dropdown>
                </b-col>
                <b-col
                  class="formula text-center"
                  @click="option.is_formula = !option.is_formula"
                >
                  <FormulaIcon
                    class="formula-on"
                    viewbox="-6 -6 100 100"
                    width="36"
                    height="36"
                    :on="true"
                  />
                  <FormulaIcon
                    class="formula-off"
                    viewbox="-6 -6 100 100"
                    width="36"
                    height="36"
                    :on="false"
                  />
                </b-col>
                <b-col class="text-center" @click="removeOrderingOption(oind)">
                  <TrashIcon viewbox="-7 -7 100 100" width="35" height="35" />
                </b-col>
              </b-row>
              
              <!-- Checkbox below option to mark as correct -->
              <b-row class="mt-2">
                <b-col cols="12" class="px-3">
                  <b-form-checkbox
                    v-model="option.correct"
                    :value="true"
                    :unchecked-value="false"
                    @change="onOrderingCheckboxChange(oind, $event)"
                  >
                    Marcar como respuesta correcta
                  </b-form-checkbox>
                </b-col>
              </b-row>

              <b-form-row class="px-3 w-100 mt-2" v-if="option.audio">
                <div class="mx-2 h6 text-muted">
                  <v-icon name="paperclip" />
                  {{ option.audio ? "audio.mp3" : "" }}
                  <b-button
                    class="ml-1 btn-circle"
                    pill
                    size="sm"
                    variant="danger"
                    @click="deleteAudio(option)"
                  >
                    <v-icon name="trash-alt" />
                  </b-button>
                </div>
              </b-form-row>

              <b-form-row class="px-3 w-100 mt-2" v-if="option.image">
                <div class="mx-2 h6 text-muted">
                  <v-icon name="paperclip" />
                  {{
                    option.image
                      ? option.image.filename
                        ? `${option.image.filename}`
                        : option.image.substring(
                            option.image.lastIndexOf("/") + 1
                          )
                      : ""
                  }}
                  <b-button
                    class="ml-1 btn-circle"
                    pill
                    size="sm"
                    variant="danger"
                    @click="option.image = null"
                  >
                    <v-icon name="trash-alt" />
                  </b-button>
                </div>
              </b-form-row>
            </b-col>
          </b-row>
          
          <b-form-row class="w-100 px-3 py-2 text-left" style="cursor: pointer">
            <div class="text-muted">
              <p
                class="h6 mx-2 text-muted"
                @click="addOrderingOption()"
              >
                Clic acá para agregar una opción
                <v-icon name="plus-circle" scale="1.2" />
              </p>
            </div>
          </b-form-row>
        </b-col>
        <!-- <b-col cols="6">
          <div class="px-2 text-left">
            <h6>Ingresa las selecciones incorrectas</h6>
          </div>

          <b-row
            class="mx-1 align-items-center"
            v-for="option of question.options.filter((o) => !o.correct)"
            :key="`iopt-${option.index}`"
            no-gutters
          >
            <b-col cols="1" class="text-center pt-2">
              <table>
                <tr>
                  <th class="py-0 vertical-align-middle">
                    <v-icon
                      name="arrow-up-on"
                      @click="moveOptionUp(option.index, true)"
                      style="cursor: pointer"
                      scale="0.5"
                      class="text-info mt-2"
                    />
                  </th>
                </tr>
                <tr>
                  <th>
                    <v-icon
                      name="arrow-down-on"
                      @click="moveOptionDown(option.index, true)"
                      style="cursor: pointer"
                      scale="0.5"
                      class="text-info mb-2"
                    />
                  </th>
                </tr>
              </table>
            </b-col>
            <b-col cols="7">
              <b-input
                v-if="!option.is_formula"
                class="d-inline"
                size="sm"
                v-model="option.text"
              ></b-input>
              <math-field
                @blur="
                  (event) => {
                    option.text = event.target.value;
                  }
                "
                v-else
                id="formula"
                virtual-keyboard-mode="manual"
                style="height: 50px; font-size: 20pt"
              >
                {{ option.text }}
              </math-field>
            </b-col>
            <b-col class="pl-1">
              <b-dropdown
                size="sm"
                toggle-class="rounded-circle custom-dots-button"
                no-caret
              >
                <template #button-content>
                  <ThreeDotsIcon
                    viewbox="-35 10 100 120"
                    width="12"
                    height="18"
                  />
                </template>
                <b-dropdown-item href="#" @click="manageRecording(option)">
                  Agregar audio <v-icon name="microphone" scale="1" />
                </b-dropdown-item>
                <b-dropdown-item href="#" @click="attachImage(option)">
                  Agregar imagen <v-icon name="paperclip" scale="1" />
                </b-dropdown-item>
              </b-dropdown>
            </b-col>
            <b-col
              class="formula text-center"
              @click="option.is_formula = !option.is_formula"
            >
              <FormulaIcon
                class="formula-on"
                viewbox="-6 -6 100 100"
                width="36"
                height="36"
                :on="true"
              />
              <FormulaIcon
                class="formula-off"
                viewbox="-6 -6 100 100"
                width="36"
                height="36"
                :on="false"
              />
            </b-col>
            <b-col class="text-center" @click="removeOption(option.index)">
              <TrashIcon viewbox="-7 -7 100 100" width="35" height="35" />
            </b-col>

            <b-form-row class="px-3" v-if="option.audio">
              <div class="mx-2 h6 text-muted">
                <v-icon name="paperclip" />
                {{ option.audio ? "audio.mp3" : "" }}
                <b-button
                  class="ml-1 btn-circle"
                  pill
                  size="sm"
                  variant="danger"
                  @click="deleteAudio(option)"
                >
                  <v-icon name="trash-alt" />
                </b-button>
              </div>
            </b-form-row>

            <b-form-row class="px-3" v-if="option.image">
              <div class="mx-2 h6 text-muted">
                <v-icon name="paperclip" />
                {{
                  option.image
                    ? option.image.filename
                      ? `${option.image.filename}`
                      : option.image.substring(
                          option.image.lastIndexOf("/") + 1
                        )
                    : ""
                }}
                <b-button
                  class="ml-1 btn-circle"
                  pill
                  size="sm"
                  variant="danger"
                  @click="option.image = null"
                >
                  <v-icon name="trash-alt" />
                </b-button>
              </div>
            </b-form-row>
          </b-row>
          <b-form-row class="w-100 px-3 py-2 text-left" style="cursor: pointer">
            <div class="text-muted">
              <p
                class="h6 mx-2"
                @click="question.options.push(getEmptyOption())"
              >
                Clic acá para agregar una alternativa
                <v-icon name="plus-circle" scale="1.2" />
              </p>
            </div>
          </b-form-row>
        </b-col> -->
      </b-form-row>

      <!-- PUZZLE -->
      <b-form-row v-else-if="question.kind === 5" class="px-3">
        <b-col cols="12">
          <div class="px-2 text-left">
            <h6>Debes armar esta figura usando 3 piezas:</h6>
          </div>
          <b-row class="px-2 pb-2">
            <b-col cols="3">
              <div class="puzzle-target d-flex align-items-center justify-content-center" @click="attachImage(question)">
                <div v-if="!(question.image)">
                  <small class="text-muted">Clic para subir figura objetivo</small>
                </div>
                <div v-else>
                  <b-img :src="question.image.file ? question.image_url : question.image" width="150" />
                </div>
              </div>
            </b-col>
            <b-col cols="9" v-if="question.image">
              <b-form-row>
                <b-col cols="6">
                  <b-form-group label="Ancho (puntos PDF)" label-cols="5" label-class="mx-2">
                    <b-form-input
                      v-model.number="question.image_width"
                      type="number"
                      min="0"
                      size="sm"
                      placeholder="Ej: 140"
                    ></b-form-input>
                    <small class="text-muted">Ancho de la imagen en el PDF (en puntos)</small>
                  </b-form-group>
                </b-col>
                <b-col cols="6">
                  <b-form-group label="Alto (puntos PDF)" label-cols="5" label-class="mx-2">
                    <b-form-input
                      v-model.number="question.image_height"
                      type="number"
                      min="0"
                      size="sm"
                      placeholder="Ej: 140"
                    ></b-form-input>
                    <small class="text-muted">Alto de la imagen en el PDF (en puntos)</small>
                  </b-form-group>
                </b-col>
              </b-form-row>
            </b-col>
          </b-row>
          <div class="px-2 text-left mt-2">
            <h6>Estas son las piezas disponibles:</h6>
          </div>
          <b-row class="px-2">
            <b-col v-for="opt in sixOptions" :key="'pz-'+opt.index" cols="4" class="mb-3">
              <div class="piece-card" @click="attachImage(opt)">
                <span class="piece-badge">{{ opt.index + 1 }}</span>
                <template v-if="opt.image">
                  <b-img :src="opt.image.file ? opt.image_url : opt.image" fluid class="piece-image"/>
                </template>
                <template v-else>
                  <div class="piece-placeholder">Pieza {{ opt.index + 1 }}</div>
                </template>
              </div>
            </b-col>
          </b-row>
          <b-row class="mt-2">
            <b-col cols="12">
              <div class="selection-row">
                <span class="mr-3">Anota aquí el número de las 3 piezas que al juntar forman la figura completa:</span>
                <b-form-checkbox
                  v-for="opt in sixOptions"
                  :key="'pz-sel-'+opt.index"
                  v-model="opt.correct"
                  :value="true"
                  :unchecked-value="false"
                  class="mx-2"
                >Pieza {{ opt.index + 1 }}</b-form-checkbox>
              </div>
            </b-col>
          </b-row>
        </b-col>
      </b-form-row>

      <!-- GRID BUILDER -->
      <b-form-row v-else-if="question.kind === 6" class="px-3">
        <b-col cols="12">
          <b-row>
            <b-col cols="4">
              <div class="px-2 text-left">
                <h6>Configura el ejercicio de cubos</h6>
              </div>
              <b-form-group label="Filas" label-cols="6" label-class="mx-2">
                <b-form-select v-model.number="question.grid_rows" :options="[2,3,4,5].map(n=>({text: n.toString(), value: n}))" size="sm" @change="resizeGrid" />
              </b-form-group>
              <b-form-group label="Columnas" label-cols="6" label-class="mx-2">
                <b-form-select v-model.number="question.grid_cols" :options="[2,3,4,5].map(n=>({text: n.toString(), value: n}))" size="sm" @change="resizeGrid" />
              </b-form-group>
              <div class="px-2 text-left">
                <small class="text-muted">Pasa el cursor sobre una celda para elegir una pieza.</small>
              </div>
            </b-col>
            <b-col cols="8">
              <div class="px-2 text-left">
                <h6>Arma la figura objetivo</h6>
              </div>
              <div class="grid-builder" :style="gridStyle">
                <div
                  v-for="(cell, idx) in flatGrid"
                  :key="`cell-`+idx"
                  class="grid-cell"
                  :style="pieceBackground(cell)"
                  @mouseenter="showTooltip(idx)"
                  @mouseleave="hideTooltip(idx)"
                >
                  <span class="grid-cell-number">{{ cell || '-' }}</span>
                  <div class="piece-tooltip" v-show="hoveredCell === idx">
                    <div
                      v-for="n in 6"
                      :key="`opt-`+n"
                      class="piece-option"
                      :style="pieceBackground(n)"
                      @click.stop="selectPieceForCell(idx, n)"
                    ></div>
                    <div class="piece-option empty" @click.stop="selectPieceForCell(idx, null)">–</div>
                  </div>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-col>
      </b-form-row>

      <!-- MATRIX BUILDER -->
      <b-form-row v-else-if="question.kind === 7" class="px-3">
        <b-col cols="12">
          <!-- Layout Type Selection -->
          <b-row class="mb-3">
            <b-col cols="12">
              <div class="px-2 text-left">
                <h6>Tipo de Layout:</h6>
              </div>
              <b-form-radio-group
                v-model="question.matrix_layout_type"
                :options="matrixLayoutOptions"
                button-variant="outline-primary"
                buttons
                class="px-2"
              ></b-form-radio-group>
            </b-col>
          </b-row>

          <!-- Question Mark Position Selection -->
          <b-row class="mb-3">
            <b-col cols="12">
              <div class="px-2 text-left">
                <h6>Posición del símbolo '?':</h6>
              </div>
              <b-form-group label="Posición" label-cols="3" label-class="mx-2">
                <b-form-select 
                  v-model="question.matrix_question_position" 
                  :options="questionMarkPositionOptions" 
                  size="sm" 
                />
              </b-form-group>
            </b-col>
          </b-row>

          <!-- Main Exercise Matrix -->
          <b-row class="mb-3">
            <b-col cols="12">
              <div class="px-2 text-left">
                <h6>Ejercicio Principal:</h6>
              </div>
              <div class="matrix-container" :style="matrixContainerStyle">
                <div
                  v-for="(cell, idx) in matrixCells"
                  :key="`matrix-cell-`+idx"
                  class="matrix-cell"
                  :class="{ 'question-mark-cell': idx === question.matrix_question_position - 1 }"
                  @click="attachMatrixImage(idx)"
                >
                  <div v-if="cell.image" class="matrix-image-container">
                    <b-img :src="cell.image.file ? cell.image_url : cell.image" fluid />
                  </div>
                  <div v-else-if="idx === question.matrix_question_position - 1" class="question-mark">
                    ?
                  </div>
                  <div v-else class="matrix-placeholder">
                    Clic para subir imagen
                  </div>
                </div>
              </div>
            </b-col>
          </b-row>

          <!-- Answer Options -->
          <b-row class="mb-3">
            <b-col cols="12">
              <div class="px-2 text-left">
                <h6>Opciones de Respuesta:</h6>
              </div>
              <div class="answer-options-container">
                <div
                  v-for="(option, idx) in question.options"
                  :key="`answer-option-`+idx"
                  class="answer-option"
                  @click="attachAnswerImage(idx)"
                >
                  <div v-if="option.image" class="answer-image-container">
                    <b-img :src="option.image.file ? option.image_url : option.image" fluid />
                  </div>
                  <div v-else class="answer-placeholder">
                    Op {{ idx + 1 }}
                  </div>
                  <div class="answer-number">{{ idx + 1 }}</div>
                </div>
              </div>
            </b-col>
          </b-row>

          <!-- Correct Answer Selection -->
          <b-row class="mb-3">
            <b-col cols="12">
              <div class="px-2 text-left">
                <h6>Selecciona la respuesta correcta:</h6>
              </div>
              <div class="px-2">
                <b-form-radio-group
                  v-model="selectedCorrectAnswer"
                  :options="correctAnswerOptions"
                  button-variant="outline-success"
                  buttons
                ></b-form-radio-group>
              </div>
            </b-col>
          </b-row>
        </b-col>
      </b-form-row>

      <!-- VISUAL KEY (Claves y Codificación Visual) -->
      <b-form-row v-else-if="question.kind === 9" class="px-3">
        <b-col cols="12">
          <div class="px-2 text-left">
            <h6>Claves y Codificación Visual</h6>
          </div>
          <b-row class="mb-2">
            <b-col cols="12">
              <b-form-group label="Número de filas" label-cols="4" label-class="mx-2">
                <b-form-select
                  v-model.number="question.visual_key_rows"
                  :options="[1,2,3,4,5].map(n=>({text: n.toString(), value: n}))"
                  size="sm"
                  @change="onVisualKeyRowsChange"
                />
              </b-form-group>
            </b-col>
          </b-row>

          <!-- Keys table -->
          <div class="vk-keys-container">
            <div class="vk-keys-title">🔑 Tabla de Claves</div>
            <div class="vk-keys">
              <div v-for="k in visualKeySymbols" :key="'k-'+k.n" class="vk-key">
                <div class="vk-key-number">{{ k.n }}</div>
                <div class="vk-key-symbol">{{ k.s }}</div>
              </div>
            </div>
          </div>

          <!-- Exercise grid -->
          <div class="vk-grid-container">
            <div class="vk-grid-title">✏️ Completa dibujando el símbolo correspondiente</div>
            <div class="vk-grid" :style="{ gridTemplateColumns: `repeat(9, 1fr)` }">
              <template v-for="(row, rIdx) in (question.visual_key_grid || [])">
                <div v-for="(num, cIdx) in row" :key="`vkcell-${rIdx}-${cIdx}`" class="vk-cell">
                  <div class="vk-cell-number">{{ num }}</div>
                  <div class="vk-cell-draw"></div>
                </div>
              </template>
            </div>
          </div>
        </b-col>
      </b-form-row>

      <!-- SEARCH QUESTION BUILDER -->
      <b-form-row v-else-if="question.kind === 8 || question.kind === 10" class="px-3">
        <b-col cols="12">
          <!-- Grid Size Selection -->
          <b-row class="mb-3">
            <b-col cols="12">
              <div class="px-2 text-left">
                <h6>Tamaño de la cuadrícula (cuadrada):</h6>
              </div>
              <b-form-group label="Dimensiones" label-cols="3" label-class="mx-2">
                <b-form-select 
                  v-model="question.search_grid_size" 
                  :options="gridSizeOptions" 
                  size="sm" 
                />
              </b-form-group>
            </b-col>
          </b-row>

          <!-- Goal Symbols Configuration -->
          <b-row class="mb-3">
            <b-col cols="12">
              <div class="px-2 text-left">
                <h6>Configuración de símbolos objetivo:</h6>
              </div>
              <b-form-group label="Número de símbolos diferentes a buscar" label-cols="6" label-class="mx-2">
                <b-form-select
                  v-model="question.search_goal_symbols_count"
                  :options="goalSymbolsCountOptions"
                  size="sm"
                />
              </b-form-group>
              <b-form-group label="Repeticiones por símbolo" label-cols="6" label-class="mx-2">
                <b-form-select 
                  v-model="question.search_repetitions_per_symbol"
                  :options="repetitionsPerSymbolOptions"
                  size="sm"
                />
              </b-form-group>
            </b-col>
          </b-row>

          <!-- Symbol Sets -->
          <b-row class="mb-3">
            <b-col cols="12">
              <div class="px-2 text-left">
                <h6>Conjuntos de símbolos predefinidos:</h6>
              </div>
              <div class="px-2">
                <b-button-group class="mb-2">
                  <b-button 
                    variant="outline-primary" 
                    size="sm" 
                    @click="addPredefinedSymbols('emojis')"
                  >
                    Emojis
                  </b-button>
                  <!-- <b-button 
                    variant="outline-primary" 
                    size="sm" 
                    @click="addPredefinedSymbols('math')"
                  >
                    Símbolos matemáticos
                  </b-button>
                  <b-button 
                    variant="outline-primary" 
                    size="sm" 
                    @click="addPredefinedSymbols('arrows')"
                  >
                    Flechas
                  </b-button>
                  <b-button 
                    variant="outline-primary" 
                    size="sm" 
                    @click="addPredefinedSymbols('cards')"
                  >
                    Cartas
                  </b-button> -->
                </b-button-group>
              </div>
            </b-col>
          </b-row>

          <!-- Custom Symbols Input -->
          <b-row class="mb-3">
            <b-col cols="12">
              <div class="px-2 text-left">
                <h6>Símbolos personalizados (escribe tus propios símbolos o emojis):</h6>
              </div>
              <b-form-textarea
                v-model="question.search_custom_symbols"
                placeholder="Escribe aquí los símbolos separados por espacios, por ejemplo: 🎯 🎲 ⭐ 🔥 💎"
                rows="3"
                class="px-2"
              ></b-form-textarea>
            </b-col>
          </b-row>

          <!-- Goal Symbol Selection -->
          <b-row class="mb-3">
            <b-col cols="12">
              <div class="px-2 text-left">
                <h6>Selecciona los símbolos objetivo (los que el estudiante debe buscar):</h6>
                <small class="text-muted" v-if="goalSymbolsStatus">{{ goalSymbolsStatus }}</small>
                <!-- <br>
                <small :class="gridValidationStatus.includes('⚠️') ? 'text-danger' : gridValidationStatus.includes('✅') ? 'text-success' : 'text-info'" v-if="gridValidationStatus">
                  {{ gridValidationStatus }}
                </small> -->
              </div>
              <div class="px-2">
                <b-form-checkbox-group
                  v-model="question.search_goal_symbols"
                  :options="availableSymbols"
                  button-variant="outline-success"
                  buttons
                  class="symbol-checkbox-group"
                ></b-form-checkbox-group>
              </div>
            </b-col>
          </b-row>

          <!-- Grid Preview -->
          <b-row class="mb-3">
            <b-col cols="12">
              <div class="px-2 text-left">
                <h6>Vista previa de la cuadrícula:</h6>
              </div>
              <div class="search-grid-preview px-2">
                <div 
                  class="search-grid" 
                  :style="searchGridStyle"
                >
                  <div
                    v-for="(cell, idx) in searchGridCells"
                    :key="`search-cell-${idx}`"
                    class="search-grid-cell"
                  >
                    {{ cell }}
                  </div>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-col>
      </b-form-row>

      <!-- WRITING QUESTION BUILDER -->
      <!-- READING EVALUATION -->
      <b-form-row v-else-if="question.kind === 12" class="px-3">
        <b-col cols="12" v-if="!loadingText">
          <div class="mx-2">
            <b-button
              v-if="readingEvaluationText && readingEvaluationCourse"
              variant="primary"
              @click="analyzeReadingText()"
              class="mb-3"
            >
              Analizar Texto
            </b-button>
            <div v-else-if="question.kind === 12" class="alert alert-warning">
              <small>
                Para usar esta pregunta, asegúrate de que:
                <ul class="mb-0 mt-2">
                  <li>El material tenga un curso/grade asignado</li>
                  <li>La página tenga un texto asociado</li>
                </ul>
              </small>
            </div>
            <p v-if="readingEvaluationText && readingEvaluationCourse" class="small text-muted mb-3">
              Curso del protocolo: {{ readingEvaluationCourseName }}.
              <span v-if="!hasReadingPhrases">Si no lo analizas, el texto se analiza al guardar.</span>
            </p>
            <!-- Reading Evaluation Results Table -->
            <div v-if="question.reading_evaluation_data && question.reading_evaluation_data.phrases && question.reading_evaluation_data.phrases.length > 0" class="mt-4 reading-evaluation-table-container">
              <b-row>
                <b-checkbox v-model="question.reading_evaluation_data.show_extra_rubric">
                  Mostrar rubrica extra
                </b-checkbox>
              </b-row>
              <div class="table-responsive">
                <table class="reading-evaluation-table">
                  <thead>
                    <tr class="table-header-gradient">
                      <th class="text-left">N°</th>
                      <th class="text-left">Frase</th>
                      <th class="text-center">Palabras en la frase</th>
                      <th class="text-center">Palabras acumuladas</th>
                      <th class="text-center">Puntuación (.,;)</th>
                      <th class="text-center">Expresión (!¡¿?)</th>
                      <th class="text-center">Decodificación (errores)</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="phrase in question.reading_evaluation_data.phrases" :key="phrase.numero">
                      <td class="numeric-value">{{ phrase.numero }}</td>
                      <td class="phrase-text">{{ phrase.frase }}</td>
                      <td class="text-center numeric-value">{{ phrase.palabrasSinPuntuacion }}</td>
                      <td class="text-center numeric-value">{{ phrase.acumuladoSinPuntuacion }}</td>
                      <td class="text-center numeric-value">{{ phrase.puntuacion }}</td>
                      <td class="text-center numeric-value">{{ phrase.expresion }}</td>
                      <td class="text-center">
                        <input
                          type="number"
                          :value="phrase.decodificacion || 0"
                          @input="updateDecodificacion(phrase, $event)"
                          min="0"
                          class="decodificacion-input"
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </b-col>
        <b-col cols="12" v-else>
          <div class="text-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
            <p>Cargando texto...</p>
          </div>
        </b-col>
      </b-form-row>

      <b-form-row v-else-if="question.kind === 11" class="px-3">
        <b-col cols="12">
          <!-- Exercise Type Selection -->
          <b-row class="mb-3">
            <b-col cols="12">
              <div class="px-2 text-left">
                <h6>Tipo de ejercicio de escritura:</h6>
              </div>
              <b-form-radio-group
                v-model="question.writing_config.exercise_type"
                :options="[
                  { text: '🎨 Trazos y Caminos', value: 'traces' },
                  { text: '✍️ Caligrafía Manuscrita', value: 'caligraphy' }
                ]"
                button-variant="outline-primary"
                buttons
                class="px-2"
                @change="onWritingTypeChange"
              ></b-form-radio-group>
            </b-col>
          </b-row>

          <!-- TRACES CONFIGURATION -->
          <div v-if="question.writing_config.exercise_type === 'traces'">
            <!-- Visual Configuration -->
            <!-- <b-row class="mb-3">
              <b-col cols="12">
                <div class="px-2 text-left">
                  <h6>Configuración visual de trazos:</h6>
                </div>
                <b-row>
                  <b-col cols="6">
                    <b-form-group label="Color del túnel" label-cols="4" label-class="mx-2">
                      <b-form-input
                        type="color"
                        v-model="question.writing_config.traces_visual.lineColor"
                        size="sm"
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col cols="6">
                    <b-form-group label="Grosor interior" label-cols="4" label-class="mx-2">
                      <b-form-input
                        type="range"
                        v-model="question.writing_config.traces_visual.lineWidth"
                        min="4"
                        max="30"
                        size="sm"
                      ></b-form-input>
                      <small class="text-muted">{{ question.writing_config.traces_visual.lineWidth }}px</small>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="6">
                    <b-form-group label="Ancho del túnel" label-cols="4" label-class="mx-2">
                      <b-form-input
                        type="range"
                        v-model="question.writing_config.traces_visual.tunnelWidth"
                        min="8"
                        max="40"
                        size="sm"
                      ></b-form-input>
                      <small class="text-muted">{{ question.writing_config.traces_visual.tunnelWidth }}px</small>
                    </b-form-group>
                  </b-col>
                  <b-col cols="6">
                    <b-form-group label="Altura del bloque" label-cols="4" label-class="mx-2">
                      <b-form-input
                        type="range"
                        v-model="question.writing_config.traces_visual.boxHeight"
                        min="80"
                        max="180"
                        size="sm"
                      ></b-form-input>
                      <small class="text-muted">{{ question.writing_config.traces_visual.boxHeight }}px</small>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="6">
                    <b-form-group label="Tamaño íconos" label-cols="4" label-class="mx-2">
                      <b-form-input
                        type="range"
                        v-model="question.writing_config.traces_visual.iconSize"
                        min="30"
                        max="60"
                        size="sm"
                      ></b-form-input>
                      <small class="text-muted">{{ question.writing_config.traces_visual.iconSize }}px</small>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-col>
            </b-row> -->

            <!-- Trace Exercises List -->
            <b-row class="mb-3">
              <b-col cols="12">
                <div class="px-2 text-left">
                  <h6>Ejercicios de trazo:</h6>
                </div>
                <div class="px-2">
                  <b-button
                    variant="success"
                    size="sm"
                    @click="addTraceExercise"
                    class="mb-2"
                  >
                    ➕ Añadir Trazo
                  </b-button>
                  
                  <div
                    v-for="(trace, index) in question.writing_config.traces"
                    :key="`trace-${index}`"
                    class="exercise-item mb-2 p-2 border rounded"
                  >
                    <b-row align-v="center">
                      <b-col cols="1" class="text-center">
                        <span class="font-weight-bold">{{ index + 1 }}.</span>
                      </b-col>
                      <b-col cols="3">
                        <b-form-select
                          v-model="trace.type"
                          :options="traceTypeOptions"
                          size="sm"
                        ></b-form-select>
                      </b-col>
                      <b-col cols="2" class="text-center">
                        <b-form-select
                          v-model="trace.startIcon"
                          :options="iconOptions"
                          size="sm"
                        ></b-form-select>
                      </b-col>
                      <b-col cols="1" class="text-center">
                        <span class="text-muted">→</span>
                      </b-col>
                      <b-col cols="2" class="text-center">
                        <b-form-select
                          v-model="trace.endIcon"
                          :options="iconOptions"
                          size="sm"
                        ></b-form-select>
                      </b-col>
                      <b-col cols="2" class="text-center">
                        <b-button
                          variant="danger"
                          size="sm"
                          @click="removeTraceExercise(index)"
                        >
                          🗑️
                        </b-button>
                      </b-col>
                    </b-row>
                  </div>
                </div>
              </b-col>
            </b-row>
          </div>

          <!-- CALLIGRAPHY CONFIGURATION -->
          <div v-if="question.writing_config.exercise_type === 'caligraphy'">
            <!-- Exercise Type Selection -->
            <b-row class="mb-3">
              <b-col cols="12">
                <div class="px-2 text-left">
                  <h6>Tipo de ejercicio de caligrafía:</h6>
                </div>
                <b-form-group label="Seleccionar tipo:" label-cols="3" label-class="mx-2">
                  <b-form-select
                    v-model="question.writing_config.caligraphy.type"
                    :options="[
                      { text: 'Letras Individuales', value: 'letters' },
                      { text: 'Sílabas', value: 'syllables' },
                      { text: 'Palabras', value: 'words' },
                      { text: 'Frases', value: 'sentences' }
                    ]"
                    size="sm"
                    @change="onCaligraphyTypeChange"
                  ></b-form-select>
                </b-form-group>
              </b-col>
            </b-row>

            <!-- Letters Selection -->
            <div v-if="question.writing_config.caligraphy.type === 'letters'">
              <b-row class="mb-3">
                <b-col cols="12">
                  <div class="px-2 text-left">
                    <h6>Seleccionar letras:</h6>
                  </div>
                  <div class="px-2">
                    <div class="letter-grid">
                      <div
                        v-for="letter in letters"
                        :key="`letter-${letter}`"
                        class="letter-btn"
                        :class="{ selected: question.writing_config.caligraphy.content.includes(letter) }"
                        @click="toggleCaligraphyLetter(letter)"
                      >
                        {{ letter }}
                      </div>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </div>

            <!-- Syllables/Words/Sentences Input -->
            <div v-else>
              <b-row class="mb-3">
                <b-col cols="12">
                  <div class="px-2 text-left">
                    <h6>{{ getCaligraphyTypeLabel() }}:</h6>
                  </div>
                  <div class="px-2">
                    <div
                      v-for="(item, index) in question.writing_config.caligraphy.content"
                      :key="`caligraphy-${index}`"
                      class="word-input-group mb-2"
                    >
                      <b-form-input
                        v-model="question.writing_config.caligraphy.content[index]"
                        :placeholder="getCaligraphyPlaceholder()"
                        size="sm"
                        class="flex-grow-1"
                      ></b-form-input>
                      <b-button
                        variant="danger"
                        size="sm"
                        @click="removeCaligraphyInput(index)"
                        class="ml-2"
                      >
                        ✕
                      </b-button>
                    </div>
                    <b-button
                      variant="success"
                      size="sm"
                      @click="addCaligraphyInput"
                    >
                      + Agregar {{ getCaligraphyTypeLabel() }}
                    </b-button>
                  </div>
                </b-col>
              </b-row>
            </div>

            <!-- Visual Configuration -->
            <!-- <b-row class="mb-3">
              <b-col cols="12">
                <div class="px-2 text-left">
                  <h6>Configuración visual:</h6>
                </div>
                <b-row>
                  <b-col cols="6">
                    <b-form-group label="Tamaño de letra" label-cols="4" label-class="mx-2">
                      <b-form-input
                        type="range"
                        v-model="question.writing_config.caligraphy.fontSize"
                        min="24"
                        max="48"
                        size="sm"
                      ></b-form-input>
                      <small class="text-muted">{{ question.writing_config.caligraphy.fontSize }}px</small>
                    </b-form-group>
                  </b-col>
                  <b-col cols="6">
                    <b-form-group label-cols="4" label-class="mx-2">
                      <b-form-checkbox
                        v-model="question.writing_config.caligraphy.showGuides"
                      >
                        Mostrar líneas guía
                      </b-form-checkbox>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-col>
            </b-row> -->
          </div>
        </b-col>
      </b-form-row>
      
    </div>

    <div v-else-if="selecting" class="selecting">
      <b-row class="m-1">
        <b-col cols="10">
          <p>{{ question.question }}</p>
        </b-col>
        <b-col cols="2" class="text-right">
          <b-button
            class="ml-1"
            v-b-tooltip.hover.left
            :title="`Ver otras ${
              question.count_relatives - 1
            } versiones de esta pregunta`"
            @click="getRelatives"
            v-b-toggle.sidebar-right-relatives
          >
            <v-icon name="users" size="40px" />
          </b-button>
        </b-col>
      </b-row>
      <div v-if="question.subtags.length">
        <b-badge
          v-for="(subtag, sIndex) in question.subtags"
          :key="'sbadge-' + sIndex"
          class="mx-1"
        >
          {{ subtag.parent_name }} - {{ subtag.name }}
        </b-badge>
      </div>
      <div v-else-if="!question.subtags.length && question.tag">
        <b-badge class="mx-1">
          {{ question.tag.name }}
        </b-badge>
      </div>
      <div v-if="question.has_texts">
        Textos Asociados:
        <ul>
          <li v-for="(text, tIndex) in texts" :key="'text-' + tIndex">
            <a
              style="cursor: pointer"
              @click="openText(text)"
              v-if="canOpenText"
              >{{ text.title }}</a
            >
            <p v-else>{{ text.title }}</p>
          </li>
        </ul>
      </div>
      <div v-if="question.formulas && question.kind !== 6">
        <b-form-row
          v-for="(formula, findex) in question.formulas"
          :key="findex"
          class="px-3"
        >
          <b-col>
            <math-field
              @blur="
                (event) => {
                  change(findex, event.target.value);
                }
              "
              id="formula"
              ref="formula"
              style="height: 50px; font-size: 20pt"
              readonly="true"
            >
              {{ formula }}
            </math-field>
          </b-col>
        </b-form-row>
      </div>
      <b-row class="m-1">
        <div v-if="question.audio">
          <audio
            ref="player-question"
            :src="question.audio"
            autoplay
            @ended="nowPlaying = ''"
            @play="nowPlaying = 'question'"
          ></audio>
          <b-img
            @click="togglePlayer('question')"
            width="30px"
            class="ml-1 mr-1"
            alt="audio-img"
            :src="nowPlaying === 'question' ? repeatIcon : listenIcon"
            style="cursor: pointer"
          />
        </div>
        <div v-if="question.image">
          <v-icon
            @click="openModalImage(question.image)"
            name="paperclip"
            size="30px"
            class="ml-1 mr-1"
            style="cursor: pointer"
          />
        </div>
      </b-row>

      <div v-if="question.kind === 0">
        <div class="mb-3" v-if="question.is_count_question">
          <b-row class="m-1">
            <b-col :cols="question.number_of_images[1] > 0 ? '6' : '12'" class="d-flex flex-wrap" :class="question.number_of_images[1] > 0 ? 'border-right justify-content-center' : 'mx-auto justify-content-center align-items-center' ">
              <div v-for="(image, index) in question.number_of_images[0]" :key="index">
                <b-img
                  v-if="image_options.length > 0"
                  :src="image_options.find((img) => img.value === question.selected_images[0]).src"
                  :width="question.number_of_images[1] > 0 ? '60' : '70'"
                  class="m-1"
                  fluid
                />
              </div>
            </b-col>
            <b-col cols="6" class="d-flex flex-wrap justify-content-center" v-if="question.number_of_images[1] > 0">
              <div v-for="(image, index) in question.number_of_images[1]" :key="index">
                <b-img
                  v-if="image_options.length > 0"
                  :src="image_options.find((img) => img.value === question.selected_images[1]).src"
                  width="60"
                  class="m-1"
                  fluid
                />
              </div>
            </b-col>
          </b-row>
        </div>
        <b-row
          v-for="(alternative, aindex) of question.alternatives"
          :key="aindex"
          class="alternative m-2"
          :class="{
            alt_correct: alternative.is_correct,
            alt_incorrect: !alternative.is_correct,
          }"
        >
          <b-col cols="8">
            <p v-if="!alternative.is_formula">{{ alternative.text }}</p>
            <math-field
              class="align-middle"
              v-if="alternative.is_formula"
              :key="alternative.text"
              style="
                pointer-events: none;
                height: 50px;
                font-size: 20pt;
                margin-bottom: 10px;
              "
              id="formula"
              :read-only="true"
            >
              {{ alternative.text }}
            </math-field>
          </b-col>
          <b-col cols="4" class="text-right">
            <audio
              :ref="`player-alternative-${aindex}`"
              :src="alternative.audio"
              @ended="nowPlaying = ''"
              @play="nowPlaying = `alternative-${aindex}`"
            ></audio>
            <b-img
              v-if="alternative.audio"
              @click="altTogglePlayer(`alternative-${aindex}`)"
              width="25px"
              class="ml-1 mr-1"
              alt="audio-img"
              :src="
                nowPlaying === `alternative-${aindex}` ? repeatIcon : listenIcon
              "
              style="cursor: pointer"
            />

            <v-icon
              v-if="alternative.image"
              @click="openModalImage(alternative.image)"
              name="paperclip"
              size="30px"
              class="ml-1 mr-1"
              style="cursor: pointer"
            />
          </b-col>
        </b-row>
      </div>
      <div v-if="question.kind === 1">
        <b-row class="essay_question m-2">
          <p v-if="question.response_type === 1">Escribe una respuesta ...</p>
          <p v-else-if="question.response_type === 2">
            Adjunta una imagen para responder ...
          </p>
          <p v-else-if="question.response_type === 3">
            Graba un audio con tu respuesta ...
          </p>
          <p v-else-if="question.response_type === 4">
            Responde con una carta ...
          </p>
          <p v-else-if="question.response_type === 5">
            Responde con una noticia ...
          </p>
          <p v-else-if="question.response_type === 6">
            Responde de forma interactiva ...
          </p>
          <p v-else-if="question.response_type === 7">
            Responde usando las imágenes disponibles ...
          </p>
          <p v-else>Responde con una noticia ...</p>
        </b-row>
        <!-- Display uploaded images for open questions -->
        <div v-if="question.set_of_images && question.set_of_images.length > 0" class="m-2">
          <h6>Imágenes disponibles:</h6>
          <div class="d-flex flex-wrap">
            <div v-for="(image, index) in question.set_of_images" :key="index" class="m-2 position-relative">
              <b-img 
                :src="image" 
                alt="Imagen" 
                width="120" 
                height="120" 
                class="border rounded"
                @click="openModalImage(image)"
              />
              <b-button 
                variant="danger" 
                size="sm" 
                class="position-absolute" 
                style="top: -5px; right: -5px;"
                @click="removeImageFromSet(index)"
              >
                <v-icon name="times" />
              </b-button>
            </div>
          </div>
        </div>
      </div>

      <div v-if="question.kind === 2">
        <b-row class="dictation_question">
          <p>Ingresa lo dictado en los {{ question.dictation }} audios ...</p>
        </b-row>
      </div>

      <div v-if="question.kind === 3 || question.kind === 5">
        <b-row>
          <b-col cols="5" class="options">
            <div v-for="(option, oindex) of question.options" :key="oindex">
              <b-row v-if="option.correct" class="correct-option">
                <b-col cols="8">
                  <p>{{ option.text }}</p>
                </b-col>
                <b-col cols="4" class="text-right">
                  <audio
                    :ref="`player-option-${oindex}`"
                    :src="option.audio"
                    @ended="nowPlaying = ''"
                    @play="nowPlaying = `option-${oindex}`"
                  ></audio>
                  <b-img
                    v-if="option.audio"
                    @click="altTogglePlayer(`option-${oindex}`)"
                    width="25px"
                    class="ml-1 mr-1"
                    alt="audio-img"
                    :src="
                      nowPlaying === `option-${oindex}`
                        ? repeatIcon
                        : listenIcon
                    "
                    style="cursor: pointer"
                  />

                  <v-icon
                    v-if="option.image"
                    @click="openModalImage(option.image)"
                    name="paperclip"
                    size="30px"
                    class="ml-1 mr-1"
                    style="cursor: pointer"
                  />
                </b-col>
              </b-row>
            </div>
          </b-col>
          <b-col cols="5" class="options">
            <div v-for="(option, oindex) of question.options" :key="oindex">
              <b-row v-if="!option.correct" class="incorrect-option">
                <b-col cols="8">
                  <p>{{ option.text }}</p>
                </b-col>
                <b-col cols="4" class="text-right">
                  <audio
                    :ref="`player-option-inc-${oindex}`"
                    :src="option.audio"
                    @ended="nowPlaying = ''"
                    @play="nowPlaying = `option-inc-${oindex}`"
                  ></audio>
                  <b-img
                    v-if="option.audio"
                    @click="altTogglePlayer(`option-inc-${oindex}`)"
                    width="25px"
                    class="ml-1 mr-1"
                    alt="audio-img"
                    :src="
                      nowPlaying === `option-inc-${oindex}`
                        ? repeatIcon
                        : listenIcon
                    "
                    style="cursor: pointer"
                  />
                  <v-icon
                    v-if="option.image"
                    @click="openModalImage(option.image)"
                    name="paperclip"
                    size="30px"
                    class="ml-1 mr-1"
                    style="cursor: pointer"
                  />
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>
      </div>

      <div v-if="question.kind === 7">
        <b-row class="mb-3">
          <b-col cols="12">
            <div class="matrix-container" :style="matrixContainerStyle">
              <div
                v-for="(cell, idx) in matrixCells"
                :key="`matrix-cell-`+idx"
                class="matrix-cell"
                :class="{ 'question-mark-cell': idx === question.matrix_question_position - 1 }"
              >
                <div v-if="cell.image" class="matrix-image-container">
                  <b-img :src="cell.image.file ? cell.image_url : cell.image" fluid />
                </div>
                <div v-else-if="idx === question.matrix_question_position - 1" class="question-mark">
                  ?
                </div>
                <div v-else class="matrix-placeholder">
                  Imagen {{ idx + 1 }}
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <div class="answer-options-container">
              <div
                v-for="(option, idx) in question.options"
                :key="`answer-option-`+idx"
                class="answer-option"
                :class="{ 'correct-answer': option.correct }"
              >
                <div v-if="option.image" class="answer-image-container">
                  <b-img :src="option.image.file ? option.image_url : option.image" fluid />
                </div>
                <div v-else class="answer-placeholder">
                  Op {{ idx + 1 }}
                </div>
                <div class="answer-number">{{ idx + 1 }}</div>
              </div>
            </div>
          </b-col>
        </b-row>
      </div>

      <div v-if="question.kind === 8 || question.kind === 10">
        <b-row class="mb-3">
          <b-col cols="12">
            <div class="search-grid-preview">
              <div 
                class="search-grid" 
                :style="searchGridStyle"
              >
                <div
                  v-for="(cell, idx) in searchGridCells"
                  :key="`search-cell-${idx}`"
                  class="search-grid-cell"
                >
                  {{ cell }}
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
      </div>

      <!-- WRITING QUESTION PREVIEW -->
      <div v-if="question.kind === 11">
        <b-row class="mb-3">
          <b-col cols="12">
            <div class="px-2 text-left">
              <h6>Vista previa del ejercicio de escritura:</h6>
            </div>
            <div class="writing-preview px-2">
              <!-- Traces Preview -->
              <div v-if="question.writing_config.exercise_type === 'traces'">
                <div
                  v-for="(trace, index) in question.writing_config.traces"
                  :key="`trace-preview-${index}`"
                  class="trace-preview-box mb-3 p-3 border rounded"
                >
                  <div class="d-flex align-items-center">
                    <div class="trace-icon me-3" :style="{ fontSize: question.writing_config.traces_visual.iconSize + 'px' }">
                      {{ trace.startIcon }}
                    </div>
                    <div class="trace-svg flex-grow-1" v-html="generateTraceSVG(trace)"></div>
                    <div class="trace-icon ms-3" :style="{ fontSize: question.writing_config.traces_visual.iconSize + 'px' }">
                      {{ trace.endIcon }}
                    </div>
                  </div>
                </div>
                <div v-if="question.writing_config.traces.length === 0" class="text-muted text-center py-4">
                  No hay ejercicios de trazo configurados
                </div>
              </div>

              <!-- Calligraphy Preview -->
              <div v-else-if="question.writing_config.exercise_type === 'caligraphy'">
                <div
                  v-for="(item, index) in question.writing_config.caligraphy.content"
                  :key="`caligraphy-preview-${index}`"
                  class="caligraphy-preview-box mb-3 p-3 border rounded"
                >
                  <div class="caligraphy-exercise">
                    <div class="exercise-header mb-2">
                      {{ index + 1 }}. Practica: "{{ item }}"
                    </div>
                    <div class="exercise-steps d-flex gap-3">
                      <div class="step-box step-model flex-fill p-3 border rounded">
                        <div class="step-label">MODELO</div>
                        <div v-if="question.writing_config.caligraphy.showGuides" class="guide-line mb-2"></div>
                        <div class="text-model" :style="{ fontSize: question.writing_config.caligraphy.fontSize + 'px' }">
                          {{ item }}
                        </div>
                        <div v-if="question.writing_config.caligraphy.showGuides" class="guide-line mt-2"></div>
                      </div>
                      <div class="step-box step-trace flex-fill p-3 border rounded">
                        <div class="step-label">PUNTEADO</div>
                        <div v-if="question.writing_config.caligraphy.showGuides" class="guide-line mb-2"></div>
                        <div class="text-dotted" :style="{ fontSize: question.writing_config.caligraphy.fontSize + 'px' }">
                          {{ item }}
                        </div>
                        <div v-if="question.writing_config.caligraphy.showGuides" class="guide-line mt-2"></div>
                      </div>
                      <div class="step-box step-practice flex-fill p-3 border rounded">
                        <div class="step-label">PRÁCTICA</div>
                        <div v-if="question.writing_config.caligraphy.showGuides" class="guide-line mb-2"></div>
                        <div class="practice-space" :style="{ height: (question.writing_config.caligraphy.fontSize + 10) + 'px' }"></div>
                        <div v-if="question.writing_config.caligraphy.showGuides" class="guide-line mt-2"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="question.writing_config.caligraphy.content.length === 0" class="text-muted text-center py-4">
                  No hay contenido de caligrafía configurado
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
      </div>
      <div v-if="question.kind === 13">
        <b-row class="mb-3">
          <b-col cols="12">
            <p>Pregunta con eje</p>
          </b-col>
        </b-row>
      </div>

    </div>

    <div v-else-if="listing">
      <!-- <b-row
        v-for="(relation, rIndex) in selectedHashtags"
        :key="rIndex + '-relation'"
      >
        <b-col
          v-for="(selectedHashtag, hIndex) in relation"
          :key="hIndex + '-sht'"
        >
          <b-select
            v-model="selectedHashtags[rIndex][hIndex]"
            @change="hashtagChanged(rIndex, hIndex)"
          >
            <b-select-option :value="null"
              >Seleccione
              {{
                selectedHashtagsOptions[rIndex][hIndex].relation_name
              }}</b-select-option
            >
            <b-select-option
              v-for="(child, cIndex) in selectedHashtagsOptions[rIndex][hIndex]
                ? selectedHashtagsOptions[rIndex][hIndex].children
                : []"
              :key="cIndex + '-child'"
              :value="child.id"
            >
              {{ child.name }}
            </b-select-option>
          </b-select>
        </b-col>
      </b-row> -->
      <div class="text-left mx-2 p-2" v-if="!loadingFamilies">
        <b-row>
          <b-col cols="3" class="cursor-pointer">
            <p
              class="h6 w-100"
              @click="createFromPage(materialPage, subject, grade)"
            >
              Crear nuevo ejercicio
              <v-icon name="plus-circle" scale="1.2" style="cursor: pointer" />
            </p>
          </b-col>
        </b-row>
        <hr />
        <div
          v-for="family in families.filter(
            (f) => !pushedFamilies.includes(f.id)
          )"
          :key="family.id"
        >
          <question-row-component
            :question="family.most_popular"
            :textRelated="family.text_related"
            :ejeRelated="family.eje_related"
            @open-question="selectQuestion(family.most_popular)"
            @select-question="
              $emit('add-selected-question', family.most_popular, materialPage)
            "
          />

          <hr />
        </div>
      </div>
      <b-row class="text-left mx-2 p-2" v-else>
        <b-col class="text-center">
          <b-spinner variant="primary" label="Spinning"></b-spinner>
        </b-col>
      </b-row>
      <b-row v-if="ePages > 1">
        <b-col class="text-center">
          <b-button-group>
            <b-button
              variant="outline-info"
              v-if="ePage > 1"
              @click="ePage = ePage - 1"
            >
              &#60;
            </b-button>
            <b-button
              variant="outline-info"
              :pressed="ePage === 1"
              @click="ePage = 1"
            >
              1
            </b-button>
            <b-button variant="outline-info" v-if="ePage - ePageRange / 2 > 2">
              ...</b-button
            >
            <b-button
              v-for="(p, index) in ePagesArray.filter((p) => {
                return (
                  1 < p &&
                  p < ePages &&
                  ((ePageRange < ePage &&
                    ePage - ePageRange / 2 <= p &&
                    p <= ePage + ePageRange / 2) ||
                    (ePageRange >= ePage && p <= ePageRange + 1))
                );
              })"
              :key="'page-' + index"
              :pressed="p === ePage"
              @click="ePage = p"
              variant="outline-info"
            >
              {{ p }}
            </b-button>
            <b-button
              variant="outline-info"
              v-if="ePages - 1 > ePage + ePageRange / 2"
            >
              ...</b-button
            >
            <b-button
              variant="outline-info"
              :pressed="ePage === ePages"
              @click="ePage = ePages"
            >
              {{ ePages }}</b-button
            >
            <b-button
              variant="outline-info"
              v-if="ePage < ePages"
              @click="ePage = ePage + 1"
            >
              &#62;
            </b-button>
          </b-button-group>
        </b-col>
      </b-row>
    </div>
    <b-sidebar
      id="sidebar-right-relatives"
      ref="sidebar-right-relatives"
      right
      bg-variant="white"
    >
      <div v-if="!waitingFamily" class="px-3 py-2">
        <div v-if="relatives.length > 1">
          <b-row
            v-for="relative in relatives.filter((r) => {
              return r.id !== question.id;
            })"
            :key="relative.id"
          >
            <question-card
              class="mx-2 w-100"
              :question="relative"
              @click.native="selectQuestion(relative, fromList)"
            />
          </b-row>
        </div>
        <div v-else>
          <p>No hay mas preguntas en esta familia</p>
        </div>
      </div>
      <div v-else class="px-3 py-2" align-self="center">
        <b-row>
          <b-col class="text-center">
            <b-spinner
              style="width: 3rem; height: 3rem"
              type="grow"
              label="Loading..."
            ></b-spinner>
          </b-col>
        </b-row>
      </div>
    </b-sidebar>
    <template #modal-footer>
      <div v-if="editing || creating" class="justify-content-center p-0 m-0">
        <b-button
          pill
          variant="danger"
          class="mx-1 custom-button"
          @click="discard"
          size="md"
        >
          <v-icon name="times" /> Descartar
        </b-button>
        <b-button
          pill
          variant="primary"
          class="mr-0 custom-button"
          @click="
            question.question ? save() : $refs['warning-empty-modal'].show()
          "
          :disabled="disableSave"
          size="px-3 md"
        >
          <b> Crear</b>
        </b-button>
        <b-button
          v-if="question.id && !editing"
          pill
          variant="primary"
          class="mx-1"
          @click="openRelatedMaterials"
          >Usar</b-button
        >
      </div>

      <div v-if="selecting" class="justify-content-center p-0 m-0">
        <b-button
          pill
          variant="danger"
          class="mx-1"
          v-on="fromList ? { click: close } : { click: backToList }"
        >
          <v-icon name="chevron-left" />
          <b> Volver</b>
        </b-button>
        <b-button
          v-if="!fromList"
          class="mr-0"
          pill
          variant="primary"
          @click="
            addToPage();
            backToList();
          "
        >
          <b>Seleccionar</b>
        </b-button>
        <b-button
          v-if="isGlobal"
          class="mr-0"
          pill
          variant="primary"
          @click="addToSchool(question.id)"
        >
          <b>Añadir a mi escuela</b>
        </b-button>
        <b-button
          class="mr-0"
          pill
          variant="primary"
          @click="editQuestion"
          :disabled="disableSave"
        >
          <b><v-icon name="edit" /> Editar</b>
        </b-button>
        <b-button
          v-if="question.id && !editing"
          pill
          variant="primary"
          class="mx-1"
          @click="openRelatedMaterials"
          >Usar</b-button
        >
      </div>
    </template>
  </b-modal>
</template>
<script>
import AudioRecordingModal from "@/components/custom-materials/modals/AudioRecordingModal";
import AdditionalInstructionModal from "@/components/custom-tests/modals/AdditionalInstructionModal";
import MultipleAudioRecorder from "@/components/custom-materials/modals/MultipleAudioRecorder";
import EvaluationMetricModal from "@/components/custom-materials/modals/EvaluationMetricModal";
import TextManagerModal from "@/components/custom-materials/modals/TextManagerModal";
import TagsComponent from "@/components/custom-tests/miscellaneous/TagsComponent";
import customMaterialService from "@/services/customMaterialService";
import customTestService from "@/services/customTestService";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import vueFilePond from "vue-filepond";
import QuestionRowComponent from "@/components/custom-materials/miscellaneous/QuestionRowComponent";
import FormulaIcon from "../icons/FormulaIcon";
import MicrophoneIcon from "../icons/MicrophoneIcon";
import ClipIcon from "../icons/ClipIcon";
import RubricIcon from "../icons/RubricIcon";
import ThreeDotsIcon from "../icons/ThreeDotsIcon";
import TrashIcon from "../icons/TrashIcon";
import WarningEmptyModal from "@/components/custom-materials/modals/WarningEmptyModal.vue";
import RelatedMaterialsSidebar from "@/components/custom-materials/miscellaneous/RelatedMaterialsSidebar";

// Create component
const FilePond = vueFilePond(
  FilePondPluginFileValidateType,
  FilePondPluginImagePreview
);

export default {
  name: "QuestionManagerModal",
  props: {
    isGlobal: {
      type: Boolean,
      default: false,
    },
    pushedFamilies: {
      type: Array,
      required: false,
    },
  },
  components: {
    AudioRecordingModal,
    AdditionalInstructionModal,
    MultipleAudioRecorder,
    EvaluationMetricModal,
    FilePond,
    TagsComponent,
    QuestionRowComponent,
    TextManagerModal,
    FormulaIcon,
    MicrophoneIcon,
    ClipIcon,
    RubricIcon,
    ThreeDotsIcon,
    TrashIcon,
    WarningEmptyModal,
    RelatedMaterialsSidebar,
  },

  data() {
    return {
      loadingFamilies: false,
      appleIcon: require("../../../assets/img/icono-manzana.svg"),
      starIcon: require("../../../assets/img/icono-estrella.svg"),
      changed: false,
      questions: [],
      image_options: [],
      question: {
        question: "",
        pedagogical_description: "",
        formulas: [],
        additional_instruction: "",
        kind: 0,
        response_type: 0,
        col_type: 0,
        row_size_type: 0,
        dictation: 0,
        score: 1,
        text: null,
        rubric: null,
        alternatives: [],
        image: null,
        image_class: null,
        audio: null,
        audio_blob: null,
        options: [],
        dictation_audios: [],
        exercises: [],
        subtags: [],
        tag: null,
        family: "",
        is_count_question: false,
        number_of_images: [0, 0],
        selected_images: [null, null],
        matrix_layout_type: "1x6",
        matrix_question_position: 6,
        matrix_cells: [],
        show_response_box: false,
        response_rows: 5,
        response_paragraphs: 2,
        writing_config: {
          exercise_type: 'traces',  // 'traces' or 'caligraphy'
          traces: [],
          traces_visual: {
            lineColor: '#C48178',
            lineWidth: 10,
            tunnelWidth: 14,
            boxHeight: 120,
            iconSize: 40
          },
          caligraphy: {
            type: 'letters',  // 'letters'|'syllables'|'words'|'sentences'
            content: [],
            fontSize: 36,
            showGuides: true
          }
        },
        reading_evaluation_data: {
          course: "",
          phrases: [],
          total_words: 0,
          show_extra_rubric: false
        },
        expected_response: "",
        show_rubric: true,
      },
      per_page: 8,
      ePages: 1,
      ePage: 1,
      ePageRange: 4,
      order: "-created_at",
      fromList: false,
      creating: false,
      editing: false,
      listing: false,
      selecting: false,
      pondObject: null,
      userID: this.$store.state.login.user_id,
      disableSave: false,
      materialPage: 0,
      modalImage: "",
      replacing: false,
      currentIndex: 0,
      kinds: [
        { text: "Alternativas", value: 0 },
        { text: "Desarrollo", value: 1 },
        // {text: 'Dictado', value: 2},
        { text: "Ordenamiento", value: 3 },
        { text: "Rompecabezas", value: 5},
        { text: "Cubos", value: 6},
        { text: "Matriz", value: 7},
        { text: "Búsqueda", value: 8},
        { text: "Claves y Codificación Visual", value: 9 },
        { text: "Ejercicio de Memoria", value: 10 },
        { text: "Escritura", value: 11 },
        { text: "Evaluación de Lectura", value: 12 },
        { text: "Pregunta con eje", value: 13},
        { text: "Fono PK-A · Opciones visuales", value: 14 },
        { text: "Fono PK-B · Producción guiada", value: 15 },
        { text: "Fono PK-C · Lámina con registro", value: 16 },
        { text: "Fono PK-D · Tablero", value: 17 },
        { text: "Fono PK-E · Secuencia visual", value: 18 },
        { text: "Fono PK-F · Conversación", value: 19 },
        { text: "Fono PK-G · Alfabetización", value: 20 },
        { text: "Fono PK-H · Matriz de escenas", value: 21 },
        { text: "Fono K-I · Tareas verbales", value: 22 },
        { text: "Fono K-J · Texto estructurado", value: 23 },
      ],
      response_types: [
        { text: "Texto escrito", value: 1 },
        { text: "Imagen", value: 2 },
        { text: "Audio", value: 3 },
        { text: "Carta", value: 4 },
        { text: "Noticia", value: 5 },
        { text: "Interactivo", value: 6 },
        { text: "Interactivo Múltiple", value: 7 },
      ],
      nowPlaying: "",
      listenIcon: require("../../../assets/img/eureka_icons/icono_escuchar.svg"),
      repeatIcon: require("../../../assets/img/eureka_icons/icono_repetiraudio.svg"),
      resumeIcon: require("../../../assets/img/eureka_icons/icono_comenzar.svg"),
      pauseIcon: require("../../../assets/img/eureka_icons/icono_reproduciendo.svg"),
      icon_2: require("../../../assets/img/material_icons/Icon2.svg"),
      loadingGif: require("../../../assets/img/preloader.gif"),
      eKinds: {
        0: "Alternativas",
        1: "Desarrollo",
        2: "Dictado",
        3: "Ordenamiento",
        5: "Rompecabezas",
        6: "Cubos",
        7: "Matriz",
        8: "Búsqueda",
        9: "Claves y Codificación Visual",
        10: "Ejercicio de Memoria",
        11: "Escritura",
        12: "Evaluación de Lectura",
        13: "Pregunta con eje",
        14: "Fono PK-A · Opciones visuales",
        15: "Fono PK-B · Producción guiada",
        16: "Fono PK-C · Lámina con registro",
        17: "Fono PK-D · Tablero",
        18: "Fono PK-E · Secuencia visual",
        19: "Fono PK-F · Conversación",
        20: "Fono PK-G · Alfabetización",
        21: "Fono PK-H · Matriz de escenas",
        22: "Fono K-I · Tareas verbales",
        23: "Fono K-J · Texto estructurado",
      },
      subject: 159, // Psicopedagogía por defecto
      grade: 2,     // 1° básico por defecto
      texts: [],
      textID: "",
      preselectedHT: [],
      selectedHashtags: [],
      selectedHashtagsOptions: [],
      hashtags: [],
      families: [],
      waitingFamily: true,
      relatives: [],
      canOpenText: true,
      eje: "",
      hoveredCell: null,
      tooltipTimeout: null,
      matrixLayoutOptions: [
        { text: "2x2 (4 imágenes)", value: "2x2" },
        { text: "1x4 (4 imágenes)", value: "1x4" },
        { text: "1x6 (6 imágenes)", value: "1x6" }
      ],
      questionMarkPositionOptions: [
        { text: "Posición 1", value: 1 },
        { text: "Posición 2", value: 2 },
        { text: "Posición 3", value: 3 },
        { text: "Posición 4", value: 4 },
        { text: "Posición 5", value: 5 },
        { text: "Posición 6", value: 6 }
      ],
      correctAnswerOptions: [
        { text: "Opción 1", value: 1 },
        { text: "Opción 2", value: 2 },
        { text: "Opción 3", value: 3 },
        { text: "Opción 4", value: 4 },
        { text: "Opción 5", value: 5 },
        { text: "Opción 6", value: 6 }
      ],
      // Writing question data
      traceTypeOptions: [
        { text: 'Ondas (senoidal)', value: 'wave' },
        { text: 'Zigzag', value: 'zigzag' },
        { text: 'Arcos ∩∪', value: 'arches' },
        { text: 'Bucles pequeños', value: 'loops' },
        { text: 'Escaleras', value: 'stairs' },
        { text: 'Montañas', value: 'mountains' },
        { text: 'Mixto con baches', value: 'mix' },
        { text: 'Línea Recta', value: 'straight' }
      ],
      iconOptions: [
        { text: '🦋', value: '🦋' },
        { text: '🐶', value: '🐶' },
        { text: '🐱', value: '🐱' },
        { text: '🕷️', value: '🕷️' },
        { text: '🐭', value: '🐭' },
        { text: '🐸', value: '🐸' },
        { text: '🏠', value: '🏠' },
        { text: '🕸️', value: '🕸️' },
        { text: '🎯', value: '🎯' },
        { text: '⚽', value: '⚽' },
        { text: '🏀', value: '🏀' },
        { text: '🎪', value: '🎪' },
        { text: '🌟', value: '🌟' },
        { text: '🌈', value: '🌈' },
        { text: '🍎', value: '🍎' },
        { text: '🌺', value: '🌺' }
      ],
      letters: 'abcdefghijklmnñopqrstuvwxyz'.split(''),
      // Search question options
      gridSizeOptions: [
        { text: "3x3", value: 3 },
        { text: "4x4", value: 4 },
        { text: "5x5", value: 5 },
        { text: "6x6", value: 6 },
        { text: "7x7", value: 7 },
        { text: "8x8", value: 8 },
        { text: "9x9", value: 9 },
        { text: "10x10", value: 10 }
      ],
      predefinedSymbolSets: {
        emojis: "😀 😃 😄 😁 😆 😅 😂 🤣 😊 😇 🙂 🙃 😉 😌 😍 🥰 😘 😗 😙 😚 😋 😛 😝 😜 🤪 🤨 🧐 🤓 😎 🤩 🥳 😏 😒 😞 😔 😟 😕 🙁 ☹️ 😣 😖 😫 😩 🥺 😢 😭 😤 😠 😡 🤬 🤯 😳 🥵 🥶 😱 😨 😰 😥 😓 🤗 🤔 🤭 🤫 🤥 😶 😐 😑 😬 🙄 😯 😦 😧 😮 😲 🥱 😴 🤤 😪 😵 🤐 🥴 🤢 🤮 🤧 😷 🤒 🤕 🤑 🤠 😈 👿 👹 👺 🤡 💩 👻 💀 ☠️ 👽 👾 🤖 🎃 😺 😸 😹 😻 😼 😽 🙀 😿 😾 🎯 🎲 ⭐ 🔥 💎 🍎 🍊 🍋 🍌 🍉 🍇 🍓 🍈 🍒 🍑 🥭 🍍 🥥 🥝 🍅 🍆 🥑 🥦 🥬 🥒 🌶 🌽 🥕 🥔 🍠 🥐 🥖 🥨 🥯 🧀 🥚 🍳 🧈 🥞 🧇 🥓 🥩 🍗 🍖 🦴 🌭 🍔 🍟 🍕 🥙 🌮 🌯 🥗 🥘 🥫 🍝 🍜 🍲 🍛 🍣 🍱 🥟 🦪 🍤 🍙 🍚 🍘 🍥 🥠 🥮 🍢 🍡 🍧 🍨 🍦 🥧 🧁 🍰 🎂 🍮 🍭 🍬 🍫 🍿 🍩 🍪 🌰 🥜 🍯 🥛 🍼 ☕ 🍵 🧃 🥤 🍶 🍺 🍻 🥂 🍷 🥃 🍸 🍹 🧉 🍾 🧊 🥄 🍴 🍽 🥣 🥡 🥢 🧂",
        math: "+ − × ÷ = ≠ < > ≤ ≥ ± ∓ ∞ ∑ ∏ ∫ ∮ ∇ ∆ ∂ √ ∛ ∜ ∠ ⊥ ∥ ∟ ∧ ∨ ¬ ∀ ∃ ∈ ∉ ⊂ ⊃ ⊆ ⊇ ∪ ∩ ∅ ⊗ ⊕ ⊙ ⊚ ⊛ ⊜ ⊝ ⊞ ⊟ ⊠ ⊡ ⊢ ⊣ ⊤ ⊥ ⊦ ⊧ ⊨ ⊩ ⊪ ⊫ ⊬ ⊭ ⊮ ⊯ ⊰ ⊱ ⊲ ⊳ ⊴ ⊵ ⊶ ⊷ ⊸ ⊹ ⊺ ⊻ ⊼ ⊽ ⊾ ⊿ ⋀ ⋁ ⋂ ⋃ ⋄ ⋅ ⋆ ⋇ ⋈ ⋉ ⋊ ⋋ ⋌ ⋍ ⋎ ⋏ ⋐ ⋑ ⋒ ⋓ ⋔ ⋕ ⋖ ⋗ ⋘ ⋙ ⋚ ⋛ ⋜ ⋝ ⋞ ⋟ ⋠ ⋡ ⋢ ⋣ ⋤ ⋥ ⋦ ⋧ ⋨ ⋩ ⋪ ⋫ ⋬ ⋭ ⋮ ⋯ ⋰ ⋱ ⋲ ⋳ ⋴ ⋵ ⋶ ⋷ ⋸ ⋹ ⋺ ⋻ ⋼ ⋽ ⋾ ⋿",
        arrows: "← ↑ → ↓ ↔ ↕ ↖ ↗ ↘ ↙ ↚ ↛ ↜ ↝ ↞ ↟ ↠ ↡ ↢ ↣ ↤ ↥ ↦ ↧ ↨ ↩ ↪ ↫ ↬ ↭ ↮ ↯ ↰ ↱ ↲ ↳ ↴ ↵ ↶ ↷ ↸ ↹ ↺ ↻ ↼ ↽ ↾ ↿ ⇀ ⇁ ⇂ ⇃ ⇄ ⇅ ⇆ ⇇ ⇈ ⇉ ⇊ ⇋ ⇌ ⇍ ⇎ ⇏ ⇐ ⇑ ⇒ ⇓ ⇔ ⇕ ⇖ ⇗ ⇘ ⇙ ⇚ ⇛ ⇜ ⇝ ⇞ ⇟ ⇠ ⇡ ⇢ ⇣ ⇤ ⇥ ⇦ ⇧ ⇨ ⇩ ⇪ ⇫ ⇬ ⇭ ⇮ ⇯ ⇰ ⇱ ⇲ ⇳ ⇴ ⇵ ⇶ ⇷ ⇸ ⇹ ⇺ ⇻ ⇼ ⇽ ⇾ ⇿",
        cards: "♠ ♥ ♦ ♣ ♤ ♡ ♢ ♧"
      },
      // Visual Key (VISUAL_KEY) defaults
      visualKeyRows: 3,
      visualKeyCols: 9,
      visualKeyGrid: [],
      visualKeySymbols: [
        { n: 1, s: '/' },
        { n: 2, s: '−' },
        { n: 3, s: '△' },
        { n: 4, s: 'ⅹ' },
        { n: 5, s: '\\' },
        { n: 6, s: '○' },
        { n: 7, s: '│' },
        { n: 8, s: '+' },
        { n: 9, s: '□' }
      ],
      // id del texto de la página que se está pidiendo ("" si ninguno)
      textRequest: "",
      text: null,
    };
  },
  mounted() {
    // this.retrieveData();
    console.log("mounted");

    // Obtener las imagenes para el select
    this.getCountImages();
    
    // Cargar hashtags por defecto si subject y grade están definidos
    console.log("🔍 DEBUG mounted - subject:", this.subject, "grade:", this.grade);
    if ((this.grade || this.grade === 0) && this.subject) {
      customTestService
        .getHashtagsByContent(this.subject, this.grade)
        .then((data) => {
          console.log("🔍 DEBUG - Llamada a getHashtagsByContent(subject:", this.subject, "grade:", this.grade, ")");
          console.log("🔍 DEBUG - hashtags recibidos (IDs):", data);
          console.log("🔍 DEBUG - Cantidad de hashtags:", data ? data.length : 0);
          this.preselectedHT = data;
          console.log("🔍 DEBUG - preselectedHT actualizado:", this.preselectedHT);
          
          // Verificar qué son estos hashtags
          if (data && data.length > 0) {
            console.log("🔍 DEBUG - Primer hashtag ID:", data[0]);
            if (data.length > 1) {
              console.log("🔍 DEBUG - Segundo hashtag ID:", data[1]);
            }
          }
        })
        .catch((error) => {
          console.error("🔍 DEBUG - Error al obtener hashtags:", error);
        });
    }
  },
  destroyed() {
    console.log("destroy");
  },
  watch: {
    schoolID() {
      // this.retrieveData();
    },
    ePage() {
      if (this.hashtags.length) {
        // this.getFilteredQuestions();
        this.getFilteredFamilies();
      } else {
        // this.getPaginatedSchoolQuestions();
        this.getPaginatedSchoolFamilies();
      }
    },
    question: {
      handler() {
        if (!this.selecting) {
          this.changed = true;
        }
      },
      deep: true,
    },
    'question.kind'(val) {
      console.log('question.kind watcher triggered with value:', val);
      // Only run defaults if we're creating a new question, not editing an existing one
      if (this.creating && !this.editing) {
        if (val === 3) {
          this.ensureOrderingDefaults();
        } else if (val === 5) {
          this.ensurePuzzleDefaults();
        } else if (val === 6) {
          this.ensureGridDefaults();
        } else if (val === 7) {
          console.log('question.kind watcher calling ensureMatrixDefaults');
          this.ensureMatrixDefaults();
        } else if (val === 8 || val === 10) {
          this.ensureSearchDefaults();
        } else if (val === 9) {
          this.ensureVisualKeyDefaults();
        } else if (val === 11) {
          this.ensureWritingDefaults();
        } else if (val === 12) {
          this.ensureReadingEvaluationDefaults();
        }
      } else if (val === 12 && this.editing) {
        // Fluidez lectora también al editar (por ejemplo, si se cambia el
        // tipo): solo pone lo que falta y pide el texto de la página.
        this.ensureReadingEvaluationDefaults();
      }
    },
    'question.matrix_layout_type'() {
      if (this.question.kind === 7 && this.creating && !this.editing) {
        this.ensureMatrixDefaults();
      }
    },
    'question.search_goal_symbols_count'() {
      // Clamp value to available options if needed
      const opts = this.goalSymbolsCountOptions.map(o => o.value);
      if (opts.length && !opts.includes(this.question.search_goal_symbols_count)) {
        this.$set(this.question, 'search_goal_symbols_count', opts[opts.length - 1]);
      }
      this.validateGoalSymbols();
    },
    'question.search_goal_symbols'() {
      this.validateGoalSymbols();
    },
    'question.search_grid_size'() {
      // Changing size invalidates current layout
      this.$set(this.question, 'search_grid_layout', []);
      this.validateGoalSymbols();
    },
    'question.search_repetitions_per_symbol'() {
      // Clamp value to available options if needed
      const opts = this.repetitionsPerSymbolOptions.map(o => o.value);
      if (opts.length && !opts.includes(this.question.search_repetitions_per_symbol)) {
        this.$set(this.question, 'search_repetitions_per_symbol', opts[opts.length - 1]);
      }
      // Changing repetitions invalidates current layout
      this.$set(this.question, 'search_grid_layout', []);
      this.validateGoalSymbols();
    },
    'question.search_custom_symbols'() {
      // Clear goal symbols when custom symbols change since available symbols are different
      this.$set(this.question, 'search_goal_symbols', []);
      // Also invalidate existing layout
      this.$set(this.question, 'search_grid_layout', []);
    }
  },
  computed: {
    ePagesArray() {
      return Array.from({ length: this.ePages }, (_, i) => i + 1);
    },
    schoolID() {
      return this.$store.state.login.school;
    },
    // El curso que fija el corte de lectura del protocolo. Si la pregunta ya
    // tiene uno, manda ese: la misma pregunta se usa en materiales de
    // distintos niveles, y analizarla desde uno no debe cambiarles el corte a
    // los otros. Si no tiene, sale del curso del material.
    readingEvaluationCourse() {
      const datos = this.question && this.question.reading_evaluation_data;
      if (datos && datos.course) return String(datos.course);
      if (!this.grade && this.grade !== 0) return '';
      // Map grade enum to course string
      // Grade B1=2 -> course "1", B2=3 -> "2", ..., B8=9 -> "8"
      // Grade M1=10 -> course "9", M2=11 -> "10", M3=12 -> "11", M4=13 -> "12"
      if (this.grade >= 2 && this.grade <= 9) {
        return String(this.grade - 1);
      } else if (this.grade >= 10 && this.grade <= 13) {
        return String(this.grade - 1);
      }
      return '';
    },
    // "11" → "3° Medio", como en `reading_speed_mapping` (backend/api/utils.py)
    readingEvaluationCourseName() {
      const n = parseInt(this.readingEvaluationCourse, 10);
      if (!n) return '';
      return n <= 8 ? `${n}° Básico` : `${n - 8}° Medio`;
    },
    hasReadingPhrases() {
      const datos = this.question && this.question.reading_evaluation_data;
      return !!(datos && Array.isArray(datos.phrases) && datos.phrases.length > 0);
    },
    // El texto de la página actual todavía no llega
    loadingText() {
      return !!this.textID && this.textRequest === this.textID;
    },
    // Get text from page for reading evaluation
    readingEvaluationText() {
      if (this.materialPage === null || this.materialPage === undefined) return '';
      try {
        return this.text ? this.text.content : '';
      } catch (e) {
        console.error('Error getting page text:', e);
        return '';
      }
    },
    sixOptions() {
      // Ensure exactly 6 slots
      const arr = Array.from({ length: 6 }, (_, i) => {
        const found = (this.question && this.question.options ? this.question.options.find(o => o && o.index === i) : null);
        return found || { index: i };
      });
      return arr;
    },
    gridStyle() {
      if (!(this.question && this.question.grid_cols && this.question.grid_rows)) {
        return {};
      }
      return {
        display: 'grid',
        gridTemplateColumns: `repeat(${this.question.grid_cols}, 60px)`,
        gridTemplateRows: `repeat(${this.question.grid_rows}, 60px)`,
        gap: '6px'
      };
    },
    flatGrid() {
      const total = (this.question.grid_rows || 0) * (this.question.grid_cols || 0);
      if (!this.question.grid_layout) return Array.from({ length: total }, () => null);
      if (this.question.grid_layout.length !== total) return Array.from({ length: total }, (_, i) => this.question.grid_layout[i] || null);
      return this.question.grid_layout;
    },
    orderingCorrectOptions() {
      // Returns correct options in the saved order
      if (this.question.kind !== 3 || !this.question.options) return [];
      
      // Get the saved order from formulas (filtered to remove nulls)
      let correctIndicesOrder = [];
      try {
        if (this.question.formulas && this.question.formulas.length > 0 && typeof this.question.formulas[0] === 'string') {
          const parsed = JSON.parse(this.question.formulas[0]);
          if (parsed && Array.isArray(parsed.correct_indices)) {
            // Filter out null, undefined, and invalid values
            correctIndicesOrder = parsed.correct_indices.filter(
              idx => idx !== null && idx !== undefined && typeof idx === 'number' && !Number.isNaN(idx)
            );
          }
        }
      } catch (e) {
        // Ignore parse errors
      }
      
      // Filter options that are correct
      const correctOptions = this.question.options
        .map((opt, idx) => ({ option: opt, index: idx }))
        .filter(({ option }) => option && option.correct === true);
      
      // If we have a saved order, use it; otherwise use the order they appear in the array
      if (correctIndicesOrder.length > 0) {
        // Sort by the saved order
        const orderMap = new Map(correctIndicesOrder.map((idx, pos) => [idx, pos]));
        correctOptions.sort((a, b) => {
          const posA = orderMap.has(a.index) ? orderMap.get(a.index) : 999;
          const posB = orderMap.has(b.index) ? orderMap.get(b.index) : 999;
          return posA - posB;
        });
      }
      
      return correctOptions;
    },
    matrixContainerStyle() {
      if (!this.question.matrix_layout_type) return {};
      
      const layout = this.question.matrix_layout_type;
      if (layout === '2x2') {
        return {
          display: 'grid',
          gridTemplateColumns: 'repeat(2, 1fr)',
          gridTemplateRows: 'repeat(2, 1fr)',
          gap: '8px',
          maxWidth: '400px'
        };
      } else if (layout === '1x4') {
        return {
          display: 'grid',
          gridTemplateColumns: 'repeat(4, 1fr)',
          gridTemplateRows: '1fr',
          gap: '8px',
          maxWidth: '600px'
        };
      } else if (layout === '1x6') {
        return {
          display: 'grid',
          gridTemplateColumns: 'repeat(6, 1fr)',
          gridTemplateRows: '1fr',
          gap: '8px',
          maxWidth: '800px'
        };
      }
      return {};
    },
    matrixCells() {
      if (!this.question.matrix_layout_type) return [];
      
      const layout = this.question.matrix_layout_type;
      let cellCount = 0;
      
      if (layout === '2x2') cellCount = 4;
      else if (layout === '1x4') cellCount = 4;
      else if (layout === '1x6') cellCount = 6;
      
      // Ensure the matrix_cells array exists and has the right length
      if (!this.question.matrix_cells) {
        this.$set(this.question, 'matrix_cells', Array.from({ length: cellCount }, () => ({})));
      }
      
      const cells = this.question.matrix_cells.slice(0, cellCount);
      console.log('Matrix cells computed:', cells);
      return cells;
    },
    selectedCorrectAnswer: {
      get() {
        // Find which option is marked as correct
        if (!this.question.options) return null;
        const correctIndex = this.question.options.findIndex(option => option.correct);
        const result = correctIndex >= 0 ? correctIndex + 1 : null;
        console.log('selectedCorrectAnswer computed:', result, 'from options:', this.question.options);
        return result;
      },
      set(value) {
        console.log('selectedCorrectAnswer setter called with value:', value);
        this.updateCorrectAnswer(value);
      }
    },
    // Search question computed properties
    availableSymbols() {
      const customSymbols = this.question.search_custom_symbols ? 
        this.question.search_custom_symbols.split(' ').filter(s => s.trim()) : [];
      return customSymbols.map(symbol => ({ text: symbol, value: symbol }));
    },
    searchGridStyle() {
      if (!this.question.search_grid_size) {
        return {};
      }
      return {
        display: 'grid',
        gridTemplateColumns: `repeat(${this.question.search_grid_size}, 40px)`,
        gridTemplateRows: `repeat(${this.question.search_grid_size}, 40px)`,
        gap: '2px',
        border: '2px solid #ccc',
        padding: '5px'
      };
    },
    searchGridCells() {
      if (!this.question.search_grid_size) {
        return [];
      }
      
      // If we have a saved grid layout, use it
      if (this.question.search_grid_layout && this.question.search_grid_layout.length > 0) {
        return this.question.search_grid_layout;
      }
      
      // Otherwise generate a new grid
      return this.generateSearchGrid();
    },
    goalSymbolsStatus() {
      if (this.question.kind !== 8 && this.question.kind !== 10) return '';
      
      const maxSymbols = parseInt(this.question.search_goal_symbols_count) || 0;
      const selectedCount = (this.question.search_goal_symbols || []).length;
      
      if (maxSymbols === 0) return '';
      
      return `${selectedCount}/${maxSymbols} símbolos seleccionados`;
    },
    gridValidationStatus() {
      if (this.question.kind !== 8 && this.question.kind !== 10) return '';
      
      const selectedSymbols = this.question.search_goal_symbols || [];
      const repetitionsPerSymbol = parseInt(this.question.search_repetitions_per_symbol) || 1;
      const gridSize = parseInt(this.question.search_grid_size) || 0;
      const totalCells = gridSize * gridSize;
      const totalRequiredCells = selectedSymbols.length * repetitionsPerSymbol;
      
      if (selectedSymbols.length === 0) return '';
      
      if (totalRequiredCells > totalCells) {
        return `⚠️ No hay espacio suficiente (necesitas ${totalRequiredCells}, tienes ${totalCells})`;
      } else if (totalRequiredCells === totalCells) {
        return `✅ Perfecto: ${totalRequiredCells} espacios utilizados`;
      } else {
        return `ℹ️ Espacios disponibles: ${totalCells - totalRequiredCells} restantes`;
      }
    }
    ,
    goalSymbolsCountOptions() {
      // Fixed options: 1 to 4
      return [
        { text: '1', value: 1 },
        { text: '2', value: 2 },
        { text: '3', value: 3 },
        { text: '4', value: 4 }
      ];
    },
    repetitionsPerSymbolOptions() {
      // Fixed options: 1 to 3
      return [
        { text: '1', value: 1 },
        { text: '2', value: 2 },
        { text: '3', value: 3 }
      ];
    }
  },
  methods: {
    ensureReadingEvaluationDefaults() {
      if (this.question.kind !== 12) return;
      if (!this.question.reading_evaluation_data) this.$set(this.question, 'reading_evaluation_data', { course: '', phrases: [], total_words: 0, show_extra_rubric: false });
      this.loadReadingText();
    },
    // Pide el texto de la página para analizar la lectura, una vez por
    // textID. Si la respuesta llega cuando el editor ya está en otra pregunta
    // (se cerró y se abrió otra), se descarta: si no, se analizaría el texto
    // equivocado. Sin textID no hay nada que pedir y el editor muestra qué
    // falta.
    loadReadingText() {
      if (!this.textID || this.text || this.textRequest === this.textID) return;
      const id = this.textID;
      this.textRequest = id;
      customMaterialService.getText(id)
        .then((data) => { if (this.textID === id) this.text = data; })
        .catch((e) => { console.error('Error cargando el texto de la página:', e); })
        .finally(() => { if (this.textRequest === id) this.textRequest = ""; });
    },
    ensurePuzzleDefaults() {
      if (this.question.kind !== 5) return;
      if (!this.question.options) this.$set(this.question, 'options', []);
      // Guarantee 6 piece entries (0..5) without reassigning existing ones
      for (let i = 0; i < 6; i++) {
        if (!this.question.options.find(o => o && o.index === i)) {
          this.question.options.push({ index: i, text: `Pieza ${i + 1}`, is_formula: false, correct: false });
        }
      }
    },
    ensureOrderingDefaults() {
      if (this.question.kind !== 3) return;
      if (!this.question.options) this.$set(this.question, 'options', []);

      // Normalize options: the array order is the appearance order
      this.question.options.forEach((option, idx) => {
        this.$set(option, 'index', idx);
        if (typeof option.is_formula === 'undefined') {
          this.$set(option, 'is_formula', false);
        }
        if (typeof option.correct === 'undefined') {
          this.$set(option, 'correct', false);
        }
      });

      // Load correct answers order from formulas if available
      this.parseOrderingFromFormulas();
    },
    parseOrderingFromFormulas() {
      // This method is kept for loading existing data, but we don't need to store ordering_correct_indices
      // The order is stored in formulas and used by the computed property
      if (this.question.kind !== 3) return;
      // No need to do anything here, the computed property will handle it
    },
    onOrderingCheckboxChange(optionIndex, event) {
      const isChecked = event.target.checked;
      const option = this.question.options[optionIndex];
      if (!option) return;
      
      // Update the correct field (already done by v-model, but ensure it's set)
      this.$set(option, 'correct', isChecked);
      
      // Get current order from formulas (already filtered by getCorrectIndicesOrder)
      let correctIndicesOrder = this.getCorrectIndicesOrder();
      
      if (isChecked) {
        // Add to correct answers list (at the end) if not already there
        if (!correctIndicesOrder.includes(optionIndex)) {
          correctIndicesOrder.push(optionIndex);
        }
      } else {
        // Remove from correct answers list
        const index = correctIndicesOrder.indexOf(optionIndex);
        if (index > -1) {
          correctIndicesOrder.splice(index, 1);
        }
      }
      
      // Save the updated order to formulas (will filter out nulls)
      this.saveCorrectIndicesOrder(correctIndicesOrder);
    },
    ensureGridDefaults() {
      if (this.question.kind !== 6) return;
      if (this.question._gridInitDone) return;
      if (!this.question.grid_rows) this.$set(this.question, 'grid_rows', 2);
      if (!this.question.grid_cols) this.$set(this.question, 'grid_cols', 2);
      const total = this.question.grid_rows * this.question.grid_cols;
      if (!this.question.grid_layout || !Array.isArray(this.question.grid_layout)) {
        this.$set(this.question, 'grid_layout', Array.from({ length: total }, () => null));
      } else if (this.question.grid_layout.length !== total) {
        const curr = this.question.grid_layout.slice(0, total);
        while (curr.length < total) curr.push(null);
        this.$set(this.question, 'grid_layout', curr);
      }
      if (!this.question.options) this.$set(this.question, 'options', []);
      for (let i = 0; i < 6; i++) {
        if (!this.question.options.find(o => o && o.index === i)) {
          this.question.options.push({ index: i, text: `Pieza ${i + 1}`, is_formula: false, correct: true });
        }
      }
      // Do not sort or touch existing option objects; keep their references intact
      this.$set(this.question, '_gridInitDone', true);
    },
    resizeGrid() {
      this.ensureGridDefaults();
      const total = this.question.grid_rows * this.question.grid_cols;
      const curr = this.question.grid_layout ? this.question.grid_layout.slice(0, total) : [];
      while (curr.length < total) curr.push(null);
      this.$set(this.question, 'grid_layout', curr);
    },
    cycleCell(idx) {
      const current = this.question.grid_layout[idx];
      const next = current == null ? 1 : current >= 6 ? null : current + 1;
      this.$set(this.question.grid_layout, idx, next);
    },
    pieceBackground(n) {
      // Generate CSS background for the 6 canonical pieces
      // 1: solid yellow, 2: solid teal, 3-6: diagonal half yellow/teal (both orientations)
      if (!n) return {};
      const yellow = '#f8bf3b';
      const teal = '#08a6b2';
      if (n === 1) return { background: yellow };
      if (n === 2) return { background: teal };
      // Triangles simulated via two linear-gradients
      if (n === 3) {
        return { backgroundImage: `linear-gradient(135deg, ${yellow} 50%, transparent 50%), linear-gradient(135deg, transparent 50%, ${teal} 50%)` };
      }
      if (n === 4) {
        return { backgroundImage: `linear-gradient(135deg, ${teal} 50%, transparent 50%), linear-gradient(135deg, transparent 50%, ${yellow} 50%)` };
      }
      if (n === 5) {
        return { backgroundImage: `linear-gradient(45deg, ${yellow} 50%, transparent 50%), linear-gradient(45deg, transparent 50%, ${teal} 50%)` };
      }
      // n === 6
      return { backgroundImage: `linear-gradient(45deg, ${teal} 50%, transparent 50%), linear-gradient(45deg, transparent 50%, ${yellow} 50%)` };
    },
    parseGridFromFormulas() {
      if (this.question.kind !== 6) return;
      try {
        if (this.question.formulas && this.question.formulas.length > 0 && typeof this.question.formulas[0] === 'string') {
          const parsed = JSON.parse(this.question.formulas[0]);
          if (parsed && parsed.rows && parsed.cols && Array.isArray(parsed.layout)) {
            this.$set(this.question, 'grid_rows', parsed.rows);
            this.$set(this.question, 'grid_cols', parsed.cols);
            this.$set(this.question, 'grid_layout', parsed.layout);
          }
        }
      } catch (e) {
        console.log(e)
      }
      this.ensureGridDefaults();
    },
    parseMatrixFromFormulas() {
      if (this.question.kind !== 7) return;
      try {
        if (this.question.formulas && this.question.formulas.length > 0 && typeof this.question.formulas[0] === 'string') {
          const parsed = JSON.parse(this.question.formulas[0]);
          if (parsed && parsed.layout_type) {
            this.$set(this.question, 'matrix_layout_type', parsed.layout_type);
            this.$set(this.question, 'matrix_question_position', parsed.question_position || 6);
            this.$set(this.question, 'matrix_cells', parsed.cells || []);
            
            // Map set_of_images to matrix cells, skipping the question-mark cell
            if (this.question.set_of_images && this.question.set_of_images.length > 0) {
              console.log('Mapping set_of_images to matrix cells:', this.question.set_of_images);
              const questionIndex = (parsed.question_position || 6) - 1;
              let imageIndex = 0;
              this.question.matrix_cells = this.question.matrix_cells.map((cell, idx) => {
                const resultCell = { ...cell };
                if (idx !== questionIndex && imageIndex < this.question.set_of_images.length) {
                  resultCell.image = this.question.set_of_images[imageIndex];
                  console.log(`Mapped image ${imageIndex} to cell ${idx}:`, resultCell.image);
                  imageIndex += 1;
                } else if (idx === questionIndex) {
                  // Ensure the question-mark cell has no image
                  if (resultCell && resultCell.image) {
                    delete resultCell.image;
                  }
                }
                return resultCell;
              });
              console.log('Final matrix cells:', this.question.matrix_cells);
            } else {
              console.log('No set_of_images found for matrix question');
            }
            
            // Convert old matrix_answer_options to standard options field
            
              // If no answer_options in formulas, check if options exist in question
              if (this.question.options && Array.isArray(this.question.options)) {
                console.log('Loading options from question.options:', this.question.options);
                // Ensure all options have required fields
                this.question.options = this.question.options.map((option, index) => ({
                  index: index,
                  text: option.text || `Opción ${index + 1}`,
                  is_formula: option.is_formula || false,
                  correct: option.correct || false,
                  image: option.image || null,
                  audio: option.audio || null,
                  height: option.height || 0,
                  width: option.width || 0
                }));
                console.log('Final options from question:', this.question.options);
              }
            
          }
        }
      } catch (e) {
        console.log(e)
      }
      this.ensureMatrixDefaults();
    },
    selectPieceForCell(idx, n) {
      this.$set(this.question.grid_layout, idx, n);
      this.hoveredCell = null;
    },
    showTooltip(idx) {
      if (this.tooltipTimeout) {
        clearTimeout(this.tooltipTimeout);
        this.tooltipTimeout = null;
      }
      this.hoveredCell = idx;
    },
    hideTooltip(idx) {
      this.tooltipTimeout = setTimeout(() => {
        if (this.hoveredCell === idx) {
          this.hoveredCell = null;
        }
      }, 200);
    },
    ensureMatrixDefaults() {
      if (this.question.kind !== 7) return;
      console.log("ensureMatrixDefaults - options before:", this.question.options);
      if (!this.question.matrix_layout_type) this.$set(this.question, 'matrix_layout_type', '1x6');
      if (!this.question.matrix_question_position) this.$set(this.question, 'matrix_question_position', 6);
      
      // Initialize matrix_cells array with correct length based on layout
      let cellCount = 0;
      if (this.question.matrix_layout_type === '2x2') cellCount = 4;
      else if (this.question.matrix_layout_type === '1x4') cellCount = 4;
      else if (this.question.matrix_layout_type === '1x6') cellCount = 6;
      
      if (!this.question.matrix_cells) {
        this.$set(this.question, 'matrix_cells', Array.from({ length: cellCount }, () => ({})));
      } else {
        // Ensure the array has the correct length
        while (this.question.matrix_cells.length < cellCount) {
          this.question.matrix_cells.push({});
        }
        // Trim if too long
        if (this.question.matrix_cells.length > cellCount) {
          this.question.matrix_cells.splice(cellCount);
        }
      }
      
      // Initialize options array with 6 elements (standard options field)
      if (!this.question.options) {
        this.$set(this.question, 'options', []);
      }
      
      // Ensure we have exactly 6 options with all required fields
      for (let i = 0; i < 6; i++) {
        if (!this.question.options.find(o => o && o.index === i)) {
          this.question.options.push({
            index: i,
            text: `Opción ${i + 1}`,
            is_formula: false,
            correct: false,
            image: null,
            audio: null,
            height: 0,
            width: 0
          });
        } else {
          // Ensure existing options have all required fields (but don't override existing values)
          const option = this.question.options.find(o => o && o.index === i);
          if (option) {
            if (typeof option.index === 'undefined') this.$set(option, 'index', i);
            if (typeof option.text === 'undefined') this.$set(option, 'text', `Opción ${i + 1}`);
            if (typeof option.is_formula === 'undefined') this.$set(option, 'is_formula', false);
            if (typeof option.correct === 'undefined') this.$set(option, 'correct', false);
            if (typeof option.height === 'undefined') this.$set(option, 'height', 0);
            if (typeof option.width === 'undefined') this.$set(option, 'width', 0);
            // Don't override image and audio if they already exist
            if (typeof option.image === 'undefined') this.$set(option, 'image', null);
            if (typeof option.audio === 'undefined') this.$set(option, 'audio', null);
          }
        }
      }
      
      // Trim if too long
      if (this.question.options.length > 6) {
        this.question.options.splice(6);
      }
      
      // Set first option as correct by default if no correct option exists
      const hasCorrectOption = this.question.options.some(option => option.correct);
      if (!hasCorrectOption && this.question.options.length > 0) {
        console.log('Setting first option as correct by default');
        this.$set(this.question.options[0], 'correct', true);
      }
      console.log('Matrix defaults ensured. Options after:', this.question.options);
    },
    ensureSearchDefaults() {
      if (this.question.kind !== 8 && this.question.kind !== 10) return;
      
      // Initialize search question properties
      if (!this.question.search_grid_size) this.$set(this.question, 'search_grid_size', 5);
      if (!this.question.search_goal_symbols_count) this.$set(this.question, 'search_goal_symbols_count', 1);
      if (!this.question.search_repetitions_per_symbol) this.$set(this.question, 'search_repetitions_per_symbol', 1);
      if (!this.question.search_custom_symbols) this.$set(this.question, 'search_custom_symbols', '');
      if (!this.question.search_goal_symbols) this.$set(this.question, 'search_goal_symbols', []);
      if (!this.question.search_grid_layout) this.$set(this.question, 'search_grid_layout', []);

      // If editing an existing question, hydrate from formulas once
      try {
        if (this.question.formulas && this.question.formulas.length) {
          const parsed = JSON.parse(this.question.formulas[0]);
          if (parsed) {
            if (!this.question.search_grid_size && parsed.grid_size) {
              this.$set(this.question, 'search_grid_size', parsed.grid_size);
            }
            if ((!this.question.search_custom_symbols || this.question.search_custom_symbols.length === 0) && parsed.custom_symbols) {
              this.$set(this.question, 'search_custom_symbols', parsed.custom_symbols);
            }
            if ((!this.question.search_goal_symbols || this.question.search_goal_symbols.length === 0) && parsed.goal_symbols) {
              this.$set(this.question, 'search_goal_symbols', parsed.goal_symbols);
            }
            if (!this.question.search_repetitions_per_symbol && parsed.repetitions_per_symbol) {
              this.$set(this.question, 'search_repetitions_per_symbol', parsed.repetitions_per_symbol);
            }
            if ((!this.question.search_grid_layout || this.question.search_grid_layout.length === 0) && parsed.grid_layout) {
              this.$set(this.question, 'search_grid_layout', parsed.grid_layout);
            }
          }
        }
      } catch (e) { /* ignore */ }
    },
    // VISUAL KEY (kind 9)
    ensureVisualKeyDefaults() {
      if (this.question.kind !== 9) return;
      if (!this.question.visual_key_rows) this.$set(this.question, 'visual_key_rows', 3);
      // Always enforce 9 columns for visual key grid
      this.$set(this.question, 'visual_key_cols', 9);
      if (!this.question.visual_key_grid || !Array.isArray(this.question.visual_key_grid)) {
        this.$set(this.question, 'visual_key_grid', this.generateVisualKeyGrid());
      }
    },
    parseVisualKeyFromFormulas() {
      if (this.question.kind !== 9) return;
      try {
        if (this.question.formulas && this.question.formulas.length > 0 && typeof this.question.formulas[0] === 'string') {
          const parsed = JSON.parse(this.question.formulas[0]);
          if (parsed && (parsed.kind_code === 'VISUAL_KEY' || (parsed.rows && parsed.grid))) {
            if (parsed.rows) this.$set(this.question, 'visual_key_rows', parsed.rows);
            this.$set(this.question, 'visual_key_cols', 9);
            if (Array.isArray(parsed.grid) && parsed.grid.length) {
              this.$set(this.question, 'visual_key_grid', parsed.grid);
            }
          }
        }
      } catch (e) { /* ignore */ }
      this.ensureVisualKeyDefaults();
    },
    generateVisualKeyGrid() {
      const rows = parseInt(this.question.visual_key_rows || this.visualKeyRows) || 3;
      const cols = parseInt(this.question.visual_key_cols || this.visualKeyCols) || 9;
      // Fill grid with random numbers 1..9
      const grid = [];
      for (let r = 0; r < rows; r++) {
        const row = [];
        for (let c = 0; c < cols; c++) {
          row.push(Math.floor(Math.random() * 9) + 1);
        }
        grid.push(row);
      }
      return grid;
    },
    onVisualKeyRowsChange() {
      if (this.question.kind !== 9) return;
      this.$set(this.question, 'visual_key_grid', this.generateVisualKeyGrid());
    },
    addPredefinedSymbols(setType) {
      const symbols = this.predefinedSymbolSets[setType];
      if (symbols) {
        // Replace the symbols instead of adding them
        this.$set(this.question, 'search_custom_symbols', symbols);
      }
    },
    generateSearchGrid() {
      if (!this.question.search_grid_size) {
        return [];
      }
      
      const total = this.question.search_grid_size * this.question.search_grid_size;
      const symbols = this.availableSymbols.map(s => s.value);
      const goalSymbols = this.question.search_goal_symbols || [];
      const repetitionsPerSymbol = parseInt(this.question.search_repetitions_per_symbol) || 1;
      
      if (symbols.length === 0) {
        return Array.from({ length: total }, () => '?');
      }
      
      // Generate grid with proper symbol distribution
      const cells = [];
      
      if (goalSymbols.length > 0) {
        // Calculate how many goal symbols we need total
        const totalGoalSymbols = goalSymbols.length * repetitionsPerSymbol;
        
        if (totalGoalSymbols > total) {
          // Not enough space for all goal symbols with required repetitions
          return Array.from({ length: total }, () => '⚠️');
        }
        
        // Create array with goal symbols placed correctly
        const goalSymbolArray = [];
        goalSymbols.forEach(symbol => {
          for (let i = 0; i < repetitionsPerSymbol; i++) {
            goalSymbolArray.push(symbol);
          }
        });
        
        // Fill remaining spaces with random symbols
        const remainingSpaces = total - totalGoalSymbols;
        const otherSymbols = symbols.filter(s => !goalSymbols.includes(s));
        
        for (let i = 0; i < remainingSpaces; i++) {
          const randomSymbol = otherSymbols.length > 0 
            ? otherSymbols[Math.floor(Math.random() * otherSymbols.length)]
            : symbols[Math.floor(Math.random() * symbols.length)];
          goalSymbolArray.push(randomSymbol);
        }
        
        // Shuffle the array to randomize positions
        for (let i = goalSymbolArray.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [goalSymbolArray[i], goalSymbolArray[j]] = [goalSymbolArray[j], goalSymbolArray[i]];
        }
        
        return goalSymbolArray;
      } else {
        // No goal symbols selected, generate random grid
        for (let i = 0; i < total; i++) {
          const randomSymbol = symbols[Math.floor(Math.random() * symbols.length)];
          cells.push(randomSymbol);
        }
        return cells;
      }
    },
    validateGoalSymbols() {
      if (this.question.kind !== 8 && this.question.kind !== 10) return;
      
      const maxSymbols = parseInt(this.question.search_goal_symbols_count) || 0;
      const selectedSymbols = this.question.search_goal_symbols || [];
      const repetitionsPerSymbol = parseInt(this.question.search_repetitions_per_symbol) || 1;
      const gridSize = parseInt(this.question.search_grid_size) || 0;
      const totalCells = gridSize * gridSize;
      
      // First validate symbol count
      if (selectedSymbols.length > maxSymbols) {
        // Remove excess symbols, keeping only the first maxSymbols
        const trimmedSymbols = selectedSymbols.slice(0, maxSymbols);
        this.$set(this.question, 'search_goal_symbols', trimmedSymbols);
        
        // Show a warning message
        this.$toasted.error(`Solo puedes seleccionar máximo ${maxSymbols} símbolos objetivo. Se han deseleccionado los símbolos adicionales.`);
        return;
      }
      
      // Then validate if grid can accommodate the repetitions
      const totalRequiredCells = selectedSymbols.length * repetitionsPerSymbol;
      if (totalRequiredCells > totalCells) {
        this.$toasted.error(`No hay suficiente espacio en la cuadrícula. Necesitas ${totalRequiredCells} espacios pero solo tienes ${totalCells}. Reduce el número de símbolos o repeticiones.`);
      }
    },
    attachMatrixImage(cellIndex) {
      if (!this.question.matrix_cells) {
        this.$set(this.question, 'matrix_cells', []);
      }
      // Ensure the array has enough elements
      while (this.question.matrix_cells.length <= cellIndex) {
        this.question.matrix_cells.push({});
      }
      console.log('Attaching image to matrix cell', cellIndex, this.question.matrix_cells[cellIndex]);
      this.attachImage(this.question.matrix_cells[cellIndex]);
    },
    attachAnswerImage(optionIndex) {
      if (!this.question.options) {
        this.$set(this.question, 'options', []);
      }
      // Ensure the array has enough elements
      while (this.question.options.length <= optionIndex) {
        this.question.options.push({});
      }
      console.log('Attaching image to answer option', optionIndex, this.question.options[optionIndex]);
      this.attachImage(this.question.options[optionIndex]);
    },
    updateCorrectAnswer(value) {
      console.log('updateCorrectAnswer called with value:', value);
      console.log('Current options:', this.question.options);
      
      // Ensure options array exists
      if (!this.question.options) {
        this.$set(this.question, 'options', []);
      }
      
      // Clear all correct flags first
      this.question.options.forEach((option, index) => {
        console.log(`Setting option ${index} correct to false`);
        this.$set(option, 'correct', false);
      });
      
      // Set the selected option as correct
      if (value && this.question.options[value - 1]) {
        console.log(`Setting option ${value - 1} as correct`);
        this.$set(this.question.options[value - 1], 'correct', true);
      }
      
      console.log('Updated options:', this.question.options);
    },
    open() {
      this.question.show_rubric = true;
      this.changed = false;
      if (this.listing) {
        this.retrieveData();
      }
      if ((this.grade || this.grade === 0) && this.subject) {
        customTestService
          .getHashtagsByContent(this.subject, this.grade)
          .then((data) => {
            this.preselectedHT = data;
            if (this.listing) {
              // this.getFilters();
            }
          });
      } else if (this.listing) {
        // this.getFilters();
      }
      this.texts = [];
      if (this.question.has_texts) {
        customMaterialService.getRelatedTexts(this.question.id).then((data) => {
          this.texts = data;
        });
      }
      this.$refs["modal"].show();
      this.ensureOrderingDefaults();
      this.ensureGridDefaults();
      this.ensurePuzzleDefaults();
      this.parseGridFromFormulas();
      this.parseMatrixFromFormulas();
      this.parseVisualKeyFromFormulas();
      this.parseOrderingFromFormulas();
      this.ensureMatrixDefaults();
      this.ensureVisualKeyDefaults();
    },
    addToSchool(questionID) {
      customMaterialService
        .associateQuestionSchool({
          school: this.$store.state.login.school,
          question: questionID,
        })
        .then((data) => {
          this.$toasted.success(data.message);
        });
    },
    openText(text) {
      this.$refs["text-manager"].selectText(text, true, false);
    },
    getFilteredQuestions() {
      customMaterialService
        .getPaginatedSchoolQuestions(
          this.$store.state.login.school,
          this.ePage,
          this.per_page,
          this.order,
          this.hashtags,
          this.textID
        )
        .then((data) => {
          this.questions = data.questions;
          this.ePages = data.pages;
        })
        .catch(() =>
          this.$toasted.error("Ocurrió un problema al traer tus ejercicios")
        );
    },
    // Obtener id, nombre y src de las imagenes
    getCountImages() {
      customMaterialService.getCountImages().then((data) => {
        this.image_options = data;
      });
    },
    getFilteredFamilies() {
      this.loadingFamilies = true;
      customMaterialService
        .getPaginatedSchoolFamilies(
          this.$store.state.login.school,
          this.ePage,
          this.per_page,
          this.order,
          this.hashtags,
          false,
          this.eje,
          this.textID
        )
        .then((data) => {
          this.families = data.families;
          this.ePages = data.pages;
          this.loadingFamilies = false;
        })
        .catch(() =>
          this.$toasted.error("Ocurrió un problema al traer tus ejercicios")
        );
    },
    getFilters() {
      // this.visible = !this.visible;
      // this.selectedTag = null;
      // this.customTags = [];
      customTestService
        .getFilters("")
        .then((data) => {
          this.selectedHashtags = [];
          this.selectedHashtagsOptions = [];
          for (var i = 0; i < data.length; i++) {
            this.selectedHashtagsOptions.push([data[i]]);
            if (
              data[i].children.filter((child) => {
                return this.preselectedHT.includes(child.id);
              }).length
            ) {
              this.selectedHashtags.push([
                data[i].children.filter((child) => {
                  return this.preselectedHT.includes(child.id);
                })[0].id,
              ]);
              this.hashtagChanged(this.selectedHashtags.length - 1, i);
            } else {
              this.selectedHashtags.push([null]);
            }
          }
        })
        .catch(() =>
          this.$toasted.error("Ocurrió un problema al traer tus tags")
        );
    },
    // hashtagChanged(rIndex, hIndex) {
    //   customTestService
    //     .getFilters(this.selectedHashtags[rIndex][hIndex])
    //     .then((data) => {
    //       if (data.length) {
    //         if (this.selectedHashtags[rIndex].length === hIndex + 1) {
    //           if (
    //             data[0].children.filter((child) => {
    //               return this.preselectedHT.includes(child.id);
    //             }).length
    //           ) {
    //             this.selectedHashtags[rIndex].push(
    //               data[0].children.filter((child) => {
    //                 return this.preselectedHT.includes(child.id);
    //               })[0].id
    //             );
    //           } else {
    //             this.selectedHashtags[rIndex].push(null);
    //           }
    //           this.selectedHashtagsOptions[rIndex].push(data[0]);
    //         } else {
    //           this.$set(this.selectedHashtags[rIndex], hIndex + 1, null);
    //           this.$set(
    //             this.selectedHashtagsOptions[rIndex],
    //             hIndex + 1,
    //             data[0]
    //           );
    //           this.$set(
    //             this.selectedHashtags,
    //             rIndex,
    //             this.selectedHashtags[rIndex].slice(0, hIndex + 2)
    //           );
    //           this.$set(
    //             this.selectedHashtagsOptions,
    //             rIndex,
    //             this.selectedHashtagsOptions[rIndex].slice(0, hIndex + 2)
    //           );
    //         }
    //       }
    //       var hashtags = [];
    //       for (var i = 0; i < this.selectedHashtags.length; i++) {
    //         if (
    //           this.selectedHashtags[i][this.selectedHashtags[i].length - 1] ===
    //           null
    //         ) {
    //           hashtags.push(
    //             this.selectedHashtags[i][this.selectedHashtags[i].length - 2]
    //           );
    //         } else {
    //           hashtags.push(
    //             this.selectedHashtags[i][this.selectedHashtags[i].length - 1]
    //           );
    //         }
    //       }
    //       this.hashtags = hashtags;
    //       this.getFilteredFamilies();
    //       // console.log(hashtags);
    //     })
    //     .catch(() =>
    //       this.$toasted.error("Ocurrió un problema al traer tus tags")
    //     );
    // },
    retrieveData() {
      this.ePages = 1;
      this.ePage = 1;
      this.order = "-created_at";

      this.getPaginatedSchoolFamilies();
    },

    getPaginatedSchoolQuestions() {
      customMaterialService
        .getPaginatedSchoolQuestions(
          this.$store.state.login.school,
          this.ePage,
          this.per_page,
          this.order,
          "",
          this.textID
        )
        .then((data) => {
          this.questions = data.questions;
          this.ePages = data.pages;
        })
        .catch(() =>
          this.$toasted.error("Ocurrió un problema al traer tus preguntas")
        );
    },
    getPaginatedSchoolFamilies() {
      this.loadingFamilies = true;
      customMaterialService
        .getPaginatedFamiliesFilteredSchool(
          this.$store.state.login.school,
          this.ePage,
          this.per_page,
          this.eje,
          this.textID
        )
        .then((data) => {
          this.families = data.families;
          this.ePages = data.pages;
          this.loadingFamilies = false;
        })
        .catch(() =>
          this.$toasted.error("Ocurrió un problema al traer las preguntas")
        );
    },
    createNew(fromList = false) {
      this.changed = false;
      this.creating = true;
      this.editing = false;
      this.listing = false;
      this.selecting = false;
      this.fromList = fromList;
      if (fromList) {
        this.open();
      }
    },
    selectQuestion(question, fromList = false) {
      if (question.family !== this.question.family) {
        this.waitingFamily = true;
      }
      this.question = JSON.parse(JSON.stringify(question));
      this.$set(this.question, 'options', question.options);
      // Set default values for response box fields if not present
      if (this.question.show_response_box === undefined) {
        this.$set(this.question, 'show_response_box', false);
      }
      if (this.question.response_rows === undefined || this.question.response_rows === null) {
        this.$set(this.question, 'response_rows', 5);
      }
      if (this.question.response_paragraphs === undefined || this.question.response_paragraphs === null) {
        this.$set(this.question, 'response_paragraphs', 2);
      }
      // Set default values for image dimensions if not present
      if (this.question.image_height === undefined || this.question.image_height === null) {
        this.$set(this.question, 'image_height', 0);
      }
      if (this.question.image_width === undefined || this.question.image_width === null) {
        this.$set(this.question, 'image_width', 0);
      }
      this.creating = false;
      this.editing = false;
      this.listing = false;
      this.selecting = true;
      this.changed = false;
      this.fromList = fromList;
      if (fromList) {
        this.open();
      } else {
        this.canOpenText = false;
        this.texts = [];
        if (this.question.has_texts) {
          customMaterialService
            .getRelatedTexts(this.question.id)
            .then((data) => {
              this.texts = data;
            });
        }
      }
    },
    backToList() {
      this.$refs["sidebar-right-relatives"].hide();
      this.creating = false;
      this.editing = false;
      this.listing = true;
      this.selecting = false;
    },
    editQuestion() {
      this.$refs["sidebar-right-relatives"].hide();
      this.creating = false;
      this.editing = true;
      this.listing = false;
      this.selecting = false;
      // Una pregunta de fluidez elegida de la lista: necesita el texto de la
      // página igual que al editarla desde el material.
      this.ensureReadingEvaluationDefaults();
      this.open();
    },
    questionList(page, subject, grade, textID, eje) {
      console.log(eje);
      if (textID) {
        this.textID = textID;
      }
      this.materialPage = page;
      this.creating = false;
      this.editing = false;
      this.listing = true;
      this.selecting = false;
      this.fromList = false;
      // Solo sobrescribir si se pasaron valores válidos
      if (subject !== null && subject !== undefined) {
        this.subject = subject;
      }
      if (grade !== null && grade !== undefined) {
        this.grade = grade;
      }
      if (eje !== null && eje !== undefined) {
        this.eje = eje;
      }
      this.open();
    },
    createFromPage(page, subject, grade) {
      this.creating = true;
      this.editing = false;
      this.listing = false;
      this.selecting = false;
      this.fromList = false;
      this.changed = false;
      this.materialPage = page;
      // Si no se pasa subject o es null, usar valor por defecto (Psicopedagogía)
      if (subject !== null && subject !== undefined) {
        this.subject = subject;
      } else {
        this.subject = 159; // Psicopedagogía por defecto
      }
      // Si no se pasa grade o es null, usar valor por defecto (1° básico)
      if (grade !== null && grade !== undefined) {
        this.grade = grade;
      } else {
        this.grade = 2; // 1° básico por defecto
      }
      this.open();
    },
    editFromPage(question, page, qindex, grade, subject, textID) {
      // El texto de la página hace falta para «Analizar Texto» (fluidez
      // lectora). Se limpia el de la pregunta anterior: podía ser de otra
      // página.
      this.textID = textID || "";
      this.text = null;
      console.log("editFromPage - original question:", question);
      console.log("editFromPage - original options:", question.options);
      this.question = JSON.parse(JSON.stringify(question));
      this.$set(this.question, 'options', question.options);
      // Ensure set_of_images is properly copied
      if (question.set_of_images) {
        this.$set(this.question, 'set_of_images', question.set_of_images);
      }
      // Clear set_of_images_files when loading from server (these are server URLs, not File objects)
      if (this.question.set_of_images_files) {
        this.$set(this.question, 'set_of_images_files', []);
      }
      console.log("editFromPage - after copy:", this.question);
      console.log("editFromPage - after copy options:", this.question.options);
      this.creating = false;
      this.editing = true;
      this.listing = false;
      this.selecting = false;
      this.fromList = false;
      this.replacing = true;
      this.changed = false;
      this.waitingFamily = true;
      if (subject) {
        this.subject = subject;
      }
      if (grade) {
        this.grade = grade;
      }
      this.materialPage = page;
      this.currentIndex = qindex;
      // El watcher de `question.kind` no corre si la pregunta anterior
      // también era de fluidez (12 → 12): se llama a mano.
      this.ensureReadingEvaluationDefaults();
      this.open();
    },
    altTogglePlayer(name) {
      if (this.nowPlaying) {
        this.$refs[`player-${this.nowPlaying}`][0]["currentTime"] = 0;
      }
      this.nowPlaying = name;
      if (
        this.$refs[`player-${name}`] &&
        this.$refs[`player-${name}`][0]["paused"]
      ) {
        this.$refs[`player-${name}`][0]["play"]();
      } else {
        this.$refs[`player-${name}`][0]["currentTime"] = 0;
      }
    },
    togglePlayer(name) {
      if (this.nowPlaying) {
        this.$refs[`player-${this.nowPlaying}`]["currentTime"] = 0;
      }
      this.nowPlaying = name;
      console.log();
      if (
        this.$refs[`player-${name}`] &&
        this.$refs[`player-${name}`]["paused"]
      ) {
        console.log("toy acá");
        this.$refs[`player-${name}`]["play"]();
      } else {
        this.$refs[`player-${name}`]["currentTime"] = 0;
      }
    },
    manageRecording(obj) {
      // if(obj.audio instanceof Blob){
      //     obj.audio_blob = obj.audio
      //     obj.audio = window.URL.createObjectURL(obj.audio)
      // }
      this.$refs["audio-modal"].open(obj);
    },
    deleteAudio(obj) {
      obj.audio = null;
      obj.audio_blob = null;
    },
    openModalImage(img) {
      this.modalImage = img;
      this.$refs["image-modal"].show();
    },
    attachImage(obj) {
      this.pondObject = obj;
      this.$refs["pond-modal"].show();
    },
    gridAttachImage(opt) {
      // Attach to the specific option object reference to avoid resetting the array
      this.attachImage(opt);
    },
    openInstruction(obj) {
      this.$refs["instruction-modal"].open(obj);
    },
    getEmptyAlternative() {
      return {
        text: "",
        is_correct: false,
        is_formula: false,
      };
    },
    openMultirecordModal(question, total) {
      this.$refs["multi-audio-modal"].open(question, total);
    },

    removeOption(optIndex) {
      this.question.options = this.question.options.filter(
        (o) => o.index !== optIndex
      );
    },
    moveOptionUp(oIndex, correct) {
      let currIdx = this.question.options
        .filter((o) => o.correct === correct)
        .findIndex((o) => o.index === oIndex);
      if (currIdx === 0) {
        return;
      }
      let nextIdx = this.question.options.filter((o) => o.correct === correct)[
        currIdx - 1
      ].index;
      let temp = this.question.options[nextIdx];
      this.question.options.splice(nextIdx, 1, this.question.options[oIndex]);
      this.question.options.splice(oIndex, 1, temp);
      this.question.options[oIndex].index = oIndex;
      this.question.options[nextIdx].index = nextIdx;
    },
    moveOptionDown(oIndex, correct) {
      let options = this.question.options.filter((o) => o.correct === correct);
      let currIndex = options.findIndex((o) => o.index === oIndex);
      if (currIndex === options.length - 1) {
        return;
      }
      let prevIdx = this.question.options.filter((o) => o.correct === correct)[
        currIndex + 1
      ].index;
      let temp = this.question.options[oIndex];
      this.question.options.splice(oIndex, 1, this.question.options[prevIdx]);
      this.question.options.splice(prevIdx, 1, temp);
      this.question.options[oIndex].index = oIndex;
      this.question.options[prevIdx].index = prevIdx;
    },
    moveElementUp(alist, aidx) {
      if (aidx > 0) {
        alist.splice(aidx - 1, 2, alist[aidx], alist[aidx - 1]);
      }
    },
    moveElementDown(alist, aidx) {
      if (aidx < alist.length - 1) {
        alist.splice(aidx, 2, alist[aidx + 1], alist[aidx]);
      }
    },

    getEmptyOption(correct = false) {
      let index = this.question.options.length;
      return {
        index: index,
        text: "",
        is_formula: false,
        correct: correct,
      };
    },
    addOrderingOption() {
      if (!this.question.options) {
        this.$set(this.question, 'options', []);
      }
      const newIndex = this.question.options.length;
      this.question.options.push({
        index: newIndex,
        text: "",
        is_formula: false,
        correct: false,
      });
      // Update indices after adding
      this.ensureOrderingDefaults();
    },
    moveOrderingOptionUp(arrayIndex) {
      // Move option up in array (this is the saved order)
      if (arrayIndex === 0) return;
      
      // Get current order from formulas
      let correctIndicesOrder = this.getCorrectIndicesOrder();
      
      // Update correct answers indices: swap references to arrayIndex and arrayIndex-1
      correctIndicesOrder = correctIndicesOrder.map(idx => {
        if (idx === arrayIndex) return arrayIndex - 1;
        if (idx === arrayIndex - 1) return arrayIndex;
        return idx;
      });
      
      // Save updated order
      this.saveCorrectIndicesOrder(correctIndicesOrder);
      
      // Swap elements in array
      const temp = this.question.options[arrayIndex];
      this.$set(this.question.options, arrayIndex, this.question.options[arrayIndex - 1]);
      this.$set(this.question.options, arrayIndex - 1, temp);
      
      // Update indices to match new positions
      this.ensureOrderingDefaults();
    },
    moveOrderingOptionDown(arrayIndex) {
      // Move option down in array (this is the saved order)
      if (arrayIndex === this.question.options.length - 1) return;
      
      // Get current order from formulas
      let correctIndicesOrder = this.getCorrectIndicesOrder();
      
      // Update correct answers indices: swap references to arrayIndex and arrayIndex+1
      correctIndicesOrder = correctIndicesOrder.map(idx => {
        if (idx === arrayIndex) return arrayIndex + 1;
        if (idx === arrayIndex + 1) return arrayIndex;
        return idx;
      });
      
      // Save updated order
      this.saveCorrectIndicesOrder(correctIndicesOrder);
      
      // Swap elements in array
      const temp = this.question.options[arrayIndex];
      this.$set(this.question.options, arrayIndex, this.question.options[arrayIndex + 1]);
      this.$set(this.question.options, arrayIndex + 1, temp);
      
      // Update indices to match new positions
      this.ensureOrderingDefaults();
    },
    removeOrderingOption(arrayIndex) {
      // Get current order from formulas
      let correctIndicesOrder = this.getCorrectIndicesOrder();
      
      // Remove the option from correct answers if it's there
      const indexInCorrect = correctIndicesOrder.indexOf(arrayIndex);
      if (indexInCorrect > -1) {
        correctIndicesOrder.splice(indexInCorrect, 1);
      }
      
      // Adjust all indices greater than the removed index (decrement by 1)
      correctIndicesOrder = correctIndicesOrder.map(idx => {
        if (idx > arrayIndex) {
          return idx - 1;
        }
        return idx;
      });
      
      // Save updated order
      this.saveCorrectIndicesOrder(correctIndicesOrder);
      
      // Remove option from array
      this.question.options.splice(arrayIndex, 1);
      // Update indices after removal
      this.ensureOrderingDefaults();
    },
    getCorrectIndicesOrder() {
      // Get current order from formulas
      let correctIndicesOrder = [];
      try {
        if (this.question.formulas && this.question.formulas.length > 0 && typeof this.question.formulas[0] === 'string') {
          const parsed = JSON.parse(this.question.formulas[0]);
          if (parsed && Array.isArray(parsed.correct_indices)) {
            correctIndicesOrder = parsed.correct_indices;
          }
        }
      } catch (e) {
        // Ignore parse errors
      }
      // Filter out null, undefined, and invalid values
      return correctIndicesOrder.filter(idx => idx !== null && idx !== undefined && typeof idx === 'number' && !Number.isNaN(idx));
    },
    saveCorrectIndicesOrder(correctIndicesOrder) {
      // Filter out null, undefined, and invalid values before saving
      const filtered = correctIndicesOrder.filter(idx => idx !== null && idx !== undefined && typeof idx === 'number' && !Number.isNaN(idx));
      // Save the order to formulas
      const payload = { correct_indices: filtered };
      this.$set(this.question, 'formulas', [JSON.stringify(payload)]);
    },

    removeCorrectPosition(optionIndex) {
      // Uncheck the option
      const option = this.question.options[optionIndex];
      if (option) {
        this.$set(option, 'correct', false);
      }
      
      // Get current order and remove the index
      let correctIndicesOrder = this.getCorrectIndicesOrder();
      const indexInOrder = correctIndicesOrder.indexOf(optionIndex);
      if (indexInOrder > -1) {
        correctIndicesOrder.splice(indexInOrder, 1);
      }
      
      // Save updated order
      this.saveCorrectIndicesOrder(correctIndicesOrder);
    },

    moveCorrectPositionUp(optionIndex, currentPos) {
      if (currentPos === 0) return;
      
      // Get current order
      let correctIndicesOrder = this.getCorrectIndicesOrder();
      
      // Find the previous option index
      const prevOptionIndex = correctIndicesOrder[currentPos - 1];
      
      // Swap positions
      correctIndicesOrder[currentPos - 1] = optionIndex;
      correctIndicesOrder[currentPos] = prevOptionIndex;
      
      // Save updated order
      this.saveCorrectIndicesOrder(correctIndicesOrder);
    },

    moveCorrectPositionDown(optionIndex, currentPos) {
      // Get current order
      let correctIndicesOrder = this.getCorrectIndicesOrder();
      if (currentPos === correctIndicesOrder.length - 1) return;
      
      // Find the next option index
      const nextOptionIndex = correctIndicesOrder[currentPos + 1];
      
      // Swap positions
      correctIndicesOrder[currentPos] = nextOptionIndex;
      correctIndicesOrder[currentPos + 1] = optionIndex;
      
      // Save updated order
      this.saveCorrectIndicesOrder(correctIndicesOrder);
    },
    
    openRubric(question) {
      this.$refs["rubric-modal"].open(question);
    },
    saveRubric(rubric) {
      customMaterialService.saveRubric({
        question: this.question.id,
        rubric: rubric,
      });
    },

    closePond() {
      this.$refs["pond-modal"].hide();
    },
    associateImage() {
      let images = this.$refs.pond.getFiles();

      if (!this.pondObject) {
        return;
      }
      if (images.length < 1 && !this.pondObject.image) {
        this.$toasted.error("Debes subir una imagen para poder guardar");
        return;
      }
      if (this.pondObject.image && images.length === 0) {
        this.pondObject.image = null;
        return;
      }
      
      // Regular image handling, keep object reference and also support pieces
      this.$set(this.pondObject, "image", images[0]);
      this.$set(
        this.pondObject,
        "image_url",
        window.URL.createObjectURL(images[0].file)
      );

      this.closePond();
    },
    attachMultipleImages(obj) {
      this.pondObject = obj;
      this.$refs["multiple-images-modal"].show();
    },
    closeMultipleImagesModal() {
      this.$refs["multiple-images-modal"].hide();
    },
    associateMultipleImages() {
      let images = this.$refs.multiplePond.getFiles();
      
      if (!this.pondObject) {
        return;
      }
      
      // Initialize set_of_images if it doesn't exist
      if (!this.question.set_of_images) {
        this.$set(this.question, 'set_of_images', []);
      }
      
      // Initialize set_of_images_files to store File objects
      if (!this.question.set_of_images_files) {
        this.$set(this.question, 'set_of_images_files', []);
      }
      
      // Clear existing images and add new ones
      this.question.set_of_images = [];
      this.question.set_of_images_files = [];
      
      images.forEach(image => {
        // Only process images that have a File object (newly uploaded files)
        // Server URLs will be handled separately (they don't need to be uploaded)
        if (image.file && image.file instanceof File) {
          // Create a temporary URL for preview
          const imageUrl = window.URL.createObjectURL(image.file);
          this.question.set_of_images.push(imageUrl);
          // Store the actual File object for later upload
          this.question.set_of_images_files.push(image.file);
        } else if (image.source && typeof image.source === 'string' && !image.source.startsWith('blob:')) {
          // This is a server URL from existing images, keep it as is
          this.question.set_of_images.push(image.source);
        }
      });
      
      this.closeMultipleImagesModal();
    },
    removeImageFromSet(index) {
      if (this.question.set_of_images && this.question.set_of_images.length > index) {
        // Revoke blob URL to free memory
        const imageUrl = this.question.set_of_images[index];
        if (imageUrl && typeof imageUrl === 'string' && imageUrl.startsWith('blob:')) {
          window.URL.revokeObjectURL(imageUrl);
        }
        this.question.set_of_images.splice(index, 1);
        // Also remove from files array if it exists
        if (this.question.set_of_images_files && this.question.set_of_images_files.length > index) {
          this.question.set_of_images_files.splice(index, 1);
        }
      }
    },
    discard() {
      if (this.changed) {
        this.$refs["warning-discard-modal"].show();
      } else {
        this.close();
      }
    },
    close() {
      this.question = {
        show_rubric: true,
        question: "",
        pedagogical_description: "",
        formulas: [],
        additional_instruction: "",
        kind: 0,
        response_type: 0,
        col_type: 0,
        row_size_type: 0,
        dictation: 0,
        score: 1,
        text: null,
        image: null,
        image_class: null,
        image_height: 0,
        image_width: 0,
        audio: null,
        audio_blob: null,
        rubric: null,
        alternatives: [],
        options: [],
        dictation_audios: [],
        exercises: [],
        subtags: [],
        family: "",
        is_count_question: false,
        number_of_images: [0, 0],
        selected_images: [null, null],
        matrix_layout_type: "1x6",
        matrix_question_position: 6,
        matrix_cells: [],
        set_of_images: [],
        show_response_box: false,
        response_rows: 5,
        response_paragraphs: 2,
      };
      this.$refs["modal"].hide();
      this.modalImage = "";
      this.nowPlaying = "";
      this.pondObject = null;
      this.textID = "";
      this.text = null;
      this.textRequest = "";
      this.canOpenText = true;
      this.creating = true;
      this.editing = false;
      this.listing = false;
      this.selecting = false;
      // this.fromList = false
      this.disableSave = false;
      this.changed = false;
      this.waitingFamily = true;
      this.relatives = [];
    },
    change(findex, val) {
      this.question.formulas[findex] = val;
    },

    addToPage() {
      this.$emit("add-selected-question", this.question, this.materialPage);

      // this.close();
    },
    saveSubtags(subtags, tag) {
      customMaterialService
        .saveSubtags({ question: this.question.id, subtags: subtags, tag: tag })
        .then((data) => {
          console.log(data);
        });
    },
    saveNumberOfImages(is_count_question, number_of_images, question_id) {
      customMaterialService
        .saveNumberOfImages({
          is_count_question: is_count_question,
          number_of_images: number_of_images,
          question: question_id
        })
        .then((data) => {
          console.log(data);
        });
    },
    saveSelectedImages(question_id, selected_images) {
      customMaterialService
        .saveSelectedImages({
          question: question_id,
          selected_images: selected_images
        })
        .then((data) => {
          console.log(data);
        });
    },
    deleteFormula(index) {
      this.question.formulas.splice(index, 1);
      console.log(this.question.formulas);
    },
    // Funcion para elegir una imagen aleatoria del array de imagenes
    pickRandom(image_options) {
      let randomIndex = Math.floor(Math.random() * image_options.length);
      let randomElement = image_options[randomIndex];

      return randomElement.value;
    },
    validateMatrixQuestion() {
      console.log('Validating matrix question...');
      
      // Check if options exist and have required fields
      if (!this.question.options || !Array.isArray(this.question.options)) {
        this.$toasted.error('Las opciones de respuesta son requeridas');
        return false;
      }
      
      if (this.question.options.length !== 6) {
        this.$toasted.error('Debe haber exactamente 6 opciones de respuesta');
        return false;
      }
      
      // Validate each option
      for (let i = 0; i < this.question.options.length; i++) {
        const option = this.question.options[i];
        
        // Check required fields
        if (typeof option.index === 'undefined' || option.index !== i) {
          this.$toasted.error(`La opción ${i + 1} debe tener un índice válido`);
          return false;
        }
        
        if (typeof option.correct === 'undefined') {
          this.$toasted.error(`La opción ${i + 1} debe tener el campo 'correct' definido`);
          return false;
        }
        
        if (typeof option.is_formula === 'undefined') {
          this.$toasted.error(`La opción ${i + 1} debe tener el campo 'is_formula' definido`);
          return false;
        }
        
        if (typeof option.text === 'undefined') {
          this.$toasted.error(`La opción ${i + 1} debe tener el campo 'text' definido`);
          return false;
        }
        
        if (typeof option.height === 'undefined') {
          this.$toasted.error(`La opción ${i + 1} debe tener el campo 'height' definido`);
          return false;
        }
        
        if (typeof option.width === 'undefined') {
          this.$toasted.error(`La opción ${i + 1} debe tener el campo 'width' definido`);
          return false;
        }
      }
      
      // Check that exactly one option is marked as correct
      const correctOptions = this.question.options.filter(option => option.correct === true);
      if (correctOptions.length !== 1) {
        this.$toasted.error('Debe seleccionar exactamente una opción correcta');
        return false;
      }
      
      // Check matrix cells
      if (!this.question.matrix_cells || !Array.isArray(this.question.matrix_cells)) {
        this.$toasted.error('Las celdas de la matriz son requeridas');
        return false;
      }
      
      console.log('Matrix question validation passed');
      return true;
    },
    save() {
      this.disableSave = true;
      if (this.question.kind === 12 && !this.readingEvaluationReady()) {
        this.disableSave = false;
        return;
      }
      let questionMultimedia = [];
      if (this.question.kind === 6) {
        this.ensureGridDefaults();
        const payload = {
          rows: this.question.grid_rows,
          cols: this.question.grid_cols,
          layout: this.question.grid_layout,
        };
        this.$set(this.question, 'formulas', [JSON.stringify(payload)]);
      }
      
      if (this.question.kind === 7) {
        this.ensureMatrixDefaults();
        
        // Validate matrix question before saving
        if (!this.validateMatrixQuestion()) {
          this.disableSave = false;
          return;
        }
        
        // Clean matrix cells: remove blob URLs and file objects before saving
        // Existing URLs will be preserved, new files are uploaded separately
        const cleanedCells = this.question.matrix_cells.map(cell => {
          const cleanedCell = { ...cell };
          if (cleanedCell.image) {
            if (cleanedCell.image.file) {
              // New file upload - remove file object, will be uploaded separately
              delete cleanedCell.image;
            } else if (typeof cleanedCell.image === 'string' && cleanedCell.image.startsWith('blob:')) {
              // Blob URL (temporary) - remove it
              delete cleanedCell.image;
            }
            // If it's a regular URL string (existing file), keep it
          }
          return cleanedCell;
        });
        
        const payload = {
          layout_type: this.question.matrix_layout_type,
          question_position: this.question.matrix_question_position,
          cells: cleanedCells,
          answer_options: this.question.options, // Use standard options field
        };
        this.$set(this.question, 'formulas', [JSON.stringify(payload)]);
      }
      
      if (this.question.kind === 8 || this.question.kind === 10) {
        this.ensureSearchDefaults();
        // Use existing layout if present; otherwise generate once so it gets saved
        const gridLayout = (this.searchGridCells && this.searchGridCells.length)
          ? this.searchGridCells
          : this.generateSearchGrid();
        this.$set(this.question, 'search_grid_layout', gridLayout);
        
        const payload = {
          grid_size: this.question.search_grid_size,
          goal_symbols_count: this.question.search_goal_symbols_count,
          repetitions_per_symbol: this.question.search_repetitions_per_symbol,
          custom_symbols: this.question.search_custom_symbols,
          goal_symbols: this.question.search_goal_symbols,
          grid_layout: gridLayout
        };
        this.$set(this.question, 'formulas', [JSON.stringify(payload)]);
      }

      if (this.question.kind === 9) {
        this.ensureVisualKeyDefaults();
        const payload = {
          kind_code: 'VISUAL_KEY',
          rows: this.question.visual_key_rows,
          cols: this.question.visual_key_cols,
          grid: this.question.visual_key_grid
        };
        this.$set(this.question, 'formulas', [JSON.stringify(payload)]);
      }

      if (this.question.kind === 3) {
        this.ensureOrderingDefaults();
        // Get correct options indices in order
        const correctIndices = this.question.options
          .map((opt, idx) => ({ option: opt, index: idx }))
          .filter(({ option }) => option && option.correct === true)
          .map(({ index }) => index);
        
        // Get saved order from formulas and maintain it
        let correctIndicesOrder = this.getCorrectIndicesOrder();
        // Filter to only include indices that are still correct
        correctIndicesOrder = correctIndicesOrder.filter(idx => correctIndices.includes(idx));
        // Add any new correct indices that weren't in the order
        correctIndices.forEach(idx => {
          if (!correctIndicesOrder.includes(idx)) {
            correctIndicesOrder.push(idx);
          }
        });
        
        // Filter out null/undefined values before saving
        const filtered = correctIndicesOrder.filter(idx => idx !== null && idx !== undefined && typeof idx === 'number' && !Number.isNaN(idx));
        const payload = {
          correct_indices: filtered
        };
        this.$set(this.question, 'formulas', [JSON.stringify(payload)]);
      }

      // Ensure puzzle defaults before processing options
      if (this.question.kind === 5) {
        this.ensurePuzzleDefaults();
      }

      let alternativeMultimedia = [];
      let dictationMultimedia = [];
      let optionsMultimedia = [];
      let matrixImages = [];
      let rubric = this.question.rubric;
      let subtags = this.question.subtags;
      let tag = this.question.tag;
      let isCountQuestion = this.question.is_count_question;
      let numberOfImages = this.question.number_of_images;
      let selectedImages = this.question.selected_images;

      // Handle question image: files are uploaded separately
      // Only new file uploads are collected for separate upload
      // Existing file URLs should be omitted (not sent) to preserve them
      if (this.question.image) {
        if (this.question.image.file) {
          // New file upload - collect for separate upload
          questionMultimedia.push({ image: this.question.image.file });
          this.$set(this.question, 'image', null);
        } else if (typeof this.question.image === 'string' && this.question.image.startsWith('blob:')) {
          // Blob URL means file was removed or replaced, clear it
          this.$set(this.question, 'image', null);
        } else if (typeof this.question.image === 'string') {
          // Regular URL string (existing file) - delete property to preserve existing file
          // Don't send it in the payload, serializer will preserve existing value
          this.$delete(this.question, 'image');
        }
      }

      // Handle question audio: only remove if it's a new file (Blob), keep URL strings
      if (this.question.audio && this.question.changed) {
        if (this.question.audio_blob) {
          questionMultimedia.push({ audio: this.question.audio_blob });
        } else if (this.question.audio instanceof Blob) {
          questionMultimedia.push({ audio: this.question.audio });
        }
        // Only clear audio if it was changed (new upload)
        this.question.audio = null;
        delete this.question.audio_blob;
        delete this.question.changed;
      }

      // Collect matrix images for set_of_images field
      // Only collect new file uploads, preserve existing URLs in cells
      if (this.question.kind === 7 && this.question.matrix_cells) {
        this.question.matrix_cells.forEach((cell, idx) => {
          console.log(idx);
          if (cell.image) {
            if (cell.image.file) {
              // New file upload - collect for separate upload
              matrixImages.push(cell.image.file);
              // Remove file object from cell (will be cleaned in formulas payload)
              // The cell.image will be updated by the backend after upload
            }
            // Existing URLs (non-blob strings) are preserved in the cell
            // Blob URLs are removed in the formulas payload cleaning step
          }
        });
      }

      // Collect set_of_images for open questions (kind 1) with response_type 7
      // Only collect new file uploads, preserve existing URLs in the array
      let setOfImages = [];
      if (this.question.kind === 1 && this.question.set_of_images) {
        // Use stored File objects if available
        if (this.question.set_of_images_files && this.question.set_of_images_files.length > 0) {
          setOfImages = [...this.question.set_of_images_files];
        } else {
          // Fallback: try to get from pond (for backwards compatibility)
          if (this.question.set_of_images && Array.isArray(this.question.set_of_images)) {
            this.question.set_of_images.forEach((imageUrl, idx) => {
              // Check if it's a blob URL (newly uploaded) or existing URL
              if (imageUrl && typeof imageUrl === 'string' && imageUrl.startsWith('blob:')) {
                // Find the corresponding file from the pond
                const files = this.$refs.multiplePond ? this.$refs.multiplePond.getFiles() : [];
                if (files[idx] && files[idx].file) {
                  setOfImages.push(files[idx].file);
                }
              }
              // Existing URLs (non-blob) are preserved in the set_of_images array
              // They will be sent to the backend and preserved by the serializer
            });
          }
        }
        // Filter out blob URLs from set_of_images array before sending
        // Keep only existing URLs (non-blob strings)
        if (this.question.set_of_images && Array.isArray(this.question.set_of_images)) {
          this.question.set_of_images = this.question.set_of_images.filter(imageUrl => {
            // Keep existing URLs (non-blob strings), remove blob URLs (temporary)
            return !(imageUrl && typeof imageUrl === 'string' && imageUrl.startsWith('blob:'));
          });
        }
      }

      if (
        this.question.additional_instruction &&
        this.question.additional_instruction.changed
      ) {
        if (this.question.additional_instruction.del === true) {
          delete this.question.additional_instruction;
        }
      }
      if (this.question.dictation_changed) {
        this.question.dictation_audios.forEach((a, aidx) => {
          a.index = aidx;
          dictationMultimedia.push({
            index: aidx,
            audio: a.audioBlob,
            correct_answers: a.correct_answers,
          });
        });
        delete this.question.dictation_changed;
      }
      this.question.alternatives.forEach((a, idx2) => {
        a.index = idx2;
        // Handle alternative image: files are uploaded separately
        // Existing file URLs should be omitted (not sent) to preserve them
        if (a.image) {
          if (a.image.file) {
            // New file upload - collect for separate upload
            alternativeMultimedia.push({
              alternative: a.index,
              image: a.image.file,
            });
            this.$set(a, 'image', null);
          } else if (typeof a.image === 'string' && a.image.startsWith('blob:')) {
            // Blob URL means file was removed or replaced, clear it
            this.$set(a, 'image', null);
          } else if (typeof a.image === 'string') {
            // Regular URL string (existing file) - delete property to preserve existing file
            // Don't send it in the payload, serializer will preserve existing value
            this.$delete(a, 'image');
          }
        }
        // Handle alternative audio: only remove if it's a new file (Blob), keep URL strings
        if (a.audio && a.changed) {
          if (a.audio_blob) {
            alternativeMultimedia.push({
              alternative: a.index,
              audio: a.audio_blob,
            });
          } else if (a.audio instanceof Blob) {
            alternativeMultimedia.push({
              alternative: a.index,
              audio: a.audio,
            });
          }
          // Only clear audio if it was changed (new upload)
          delete a.audio_blob;
          delete a.changed;
          a.audio = null;
        }
      });

      // Process options for all question kinds that use them
      // Ensure options array exists and is valid
      if (!this.question.options) {
        this.$set(this.question, 'options', []);
      }
      
      this.question.options.forEach((o, idx) => {
        // Ensure option has required fields
        if (typeof o.index === 'undefined' || o.index === null) {
          this.$set(o, 'index', idx);
        }
        
        // Handle option image: files are uploaded separately
        // Existing file URLs should be omitted (not sent) to preserve them
        if (o.image) {
          if (o.image.file) {
            // New file upload - collect for separate upload
            optionsMultimedia.push({ index: o.index, image: o.image.file });
            this.$set(o, 'image', null);
          } else if (typeof o.image === 'string' && o.image.startsWith('blob:')) {
            // Blob URL means file was removed or replaced, clear it
            this.$set(o, 'image', null);
          } else if (typeof o.image === 'string') {
            // Regular URL string (existing file) - delete property to preserve existing file
            // Don't send it in the payload, serializer will preserve existing value
            this.$delete(o, 'image');
          }
        }
        // Handle option audio: only remove if it's a new file (Blob), keep URL strings
        if (o.audio && o.changed) {
          if (o.audio_blob) {
            optionsMultimedia.push({ index: o.index, audio: o.audio_blob });
          } else if (o.audio instanceof Blob) {
            optionsMultimedia.push({ index: o.index, audio: o.audio });
          }
          // Only clear audio if it was changed (new upload)
          o.audio = null;
          delete o.audio_blob;
          delete o.changed;
        }
      });

      if (this.question.id && !this.editing) {
        console.log("Just before call update");
        console.log(this.question);
        console.log("updating");
        customMaterialService
          .updateQuestion(this.question)
          .then((data) => {
            this.question = data;
            // SAVING RUBRIC
            if (rubric) {
              this.saveRubric(rubric);
            }
            if (tag) {
              this.saveSubtags(subtags, tag);
            }
            if (numberOfImages[0] > 0 || numberOfImages[1] > 0){
              this.saveNumberOfImages(isCountQuestion, numberOfImages, this.question.id);

              if (numberOfImages[0] > 0){
                if (selectedImages[0] == null){
                  selectedImages[0] = this.pickRandom(this.image_options);
                }
                if (selectedImages[1] == null){
                  selectedImages[1] = this.pickRandom(this.image_options);
                }
                this.saveSelectedImages(this.question.id, selectedImages);
              }
            }

            this.sendFiles(
              questionMultimedia,
              alternativeMultimedia,
              dictationMultimedia,
              optionsMultimedia,
              matrixImages,
              setOfImages
            );
            if (this.question.additional_instruction) {
              this.saveInstructions(this.question.additional_instruction);
            }
            
            // Retrieve the updated question to ensure all changes (including file uploads) are visible
            setTimeout(() => {
              customMaterialService.getQuestion(this.question.id).then((response) => {
                console.log("updated", response);
                if (!this.fromList) {
                  // Use replace-selected-question when editing to update the existing question in the material page
                  this.$emit(
                    "replace-selected-question",
                    response,
                    this.materialPage,
                    this.currentIndex
                  );
                } else {
                  this.$emit("created-question");
                }
              });

              this.$toasted.success("Guardado");
              this.disableSave = false;

              this.close();
            }, 1000);
          })
          .catch(() => {
            this.$toasted.error("Ocurrió un error al actualizar la pregunta");
            this.disableSave = false;
          });
      } else if (this.question.id && this.editing) {
        console.log("editing - using update method");
        console.log(this.question);
        // Keep question.id, options.id, and alternatives.id for update
        // Use the same media file handling logic as the update branch
        customMaterialService
          .updateQuestion(this.question)
          .then((data) => {
            this.question = data;
            // SAVING RUBRIC
            if (rubric) {
              this.saveRubric(rubric);
            }
            if (tag) {
              this.saveSubtags(subtags, tag);
            }
            if (numberOfImages[0] > 0 || numberOfImages[1] > 0){
              this.saveNumberOfImages(isCountQuestion, numberOfImages, this.question.id);

              if (numberOfImages[0] > 0){
                if (selectedImages[0] == null){
                  selectedImages[0] = this.pickRandom(this.image_options);
                }
                if (selectedImages[1] == null){
                  selectedImages[1] = this.pickRandom(this.image_options);
                }
                this.saveSelectedImages(this.question.id, selectedImages);
              }
            }

            this.sendFiles(
              questionMultimedia,
              alternativeMultimedia,
              dictationMultimedia,
              optionsMultimedia,
              matrixImages,
              setOfImages
            );
            if (this.question.additional_instruction) {
              this.saveInstructions(this.question.additional_instruction);
            }
            
            // Retrieve the updated question to ensure all changes (including file uploads) are visible
            setTimeout(() => {
              customMaterialService.getQuestion(this.question.id).then((response) => {
                console.log("updated", response);
                if (!this.fromList) {
                  // Use replace-selected-question when editing to update the existing question in the material page
                  this.$emit(
                    "replace-selected-question",
                    response,
                    this.materialPage,
                    this.currentIndex
                  );
                } else {
                  this.$emit("created-question");
                }
              });

              this.$toasted.success("Guardado");
              this.disableSave = false;

              this.close();
            }, 1000);
          })
          .catch(() => {
            this.$toasted.error("Ocurrió un error al actualizar la pregunta");
            this.disableSave = false;
          });
      } else {
        console.log("Just before call create");
        console.log(this.question);
        customMaterialService
          .createQuestion(this.question)
          .then((data) => {
            console.log(!this.fromList);
            this.question.id = data.id;
            // SAVING RUBRIC
            // console.log("Just before save rubric");
            // console.log(rubric);
            if (rubric) {
              this.saveRubric(rubric);
            }
            if (tag) {
              this.saveSubtags(subtags, tag);
            }
            if (numberOfImages[0] > 0 || numberOfImages[1] > 0){
              this.saveNumberOfImages(isCountQuestion, numberOfImages, this.question.id);

              if (numberOfImages[0] > 0){
                if (selectedImages[0] == null){
                  selectedImages[0] = this.pickRandom(this.image_options);
                }
                if (selectedImages[1] == null){
                  selectedImages[1] = this.pickRandom(this.image_options);
                }
                this.saveSelectedImages(this.question.id, selectedImages);
              }
            }

            console.log(!this.fromList);
            this.sendFiles(
              questionMultimedia,
              alternativeMultimedia,
              dictationMultimedia,
              optionsMultimedia,
              matrixImages,
              setOfImages
            );
            if (this.question.additional_instruction) {
              this.saveInstructions(this.question.additional_instruction);
            }
            console.log(!this.fromList);
            customMaterialService.associateQuestionSchool({
              question: data.id,
              school: this.schoolID,
            });
            customMaterialService.associateFamilySchool(
              data.family,
              this.schoolID
            );
            console.log(!this.fromList);
            setTimeout(() => {
              customMaterialService.getQuestion(data.id).then((response) => {
                console.log("added", response);
                if (!this.fromList) {
                  this.$emit(
                    "add-selected-question",
                    response,
                    this.materialPage
                  );
                } else {
                  this.$emit("created-question");
                }
              });

              this.$toasted.success("Guardado");

              this.disableSave = false;

              this.close();
            }, 1000);
          })
          .catch(() => {
            this.$toasted.error("Ocurrió un error al crear la pregunta");
          });
      }
    },
    sendFiles(
      questionMultimedia,
      alternativeMultimedia,
      dictationMultimedia,
      optionsMultimedia,
      matrixImages,
      setOfImages
    ) {
      questionMultimedia.forEach((q) => {
        let formData = new FormData();
        if (q.image) {
          formData.append("image", q.image);
        } else if (q.audio) {
          if (q.audio instanceof Blob) {
            formData.append(
              "audio",
              q.audio,
              `audio-${this.$moment().unix()}.wav`
            );
          } else {
            let audio_url = new URL(q.audio);
            let audio_name = audio_url.pathname.split("/").pop();
            formData.append("audio", audio_name);
          }
        } else {
          return;
        }
        formData.append("question", this.question.id);
        customMaterialService.uploadFiles(formData);
      });
      alternativeMultimedia.forEach((a) => {
        let formDataA = new FormData();
        if (a.image) {
          formDataA.append("image", a.image);
        }
        if (a.audio) {
          if (a.audio instanceof Blob) {
            formDataA.append(
              "audio",
              a.audio,
              `audio-${this.$moment().unix()}.wav`
            );
          } else {
            let audio_url = new URL(a.audio);
            let audio_name = audio_url.pathname.split("/").pop();
            formDataA.append("audio", audio_name);
          }
        }
        formDataA.append("alternative", a.alternative);
        formDataA.append("question", this.question.id);

        customMaterialService.uploadFiles(formDataA);
      });
      dictationMultimedia.forEach((a) => {
        let formDataD = new FormData();
        formDataD.append("question", this.question.id);
        formDataD.append("index", a.index);
        if (a.audio) {
          formDataD.append(
            "audio",
            a.audio,
            `audio-${this.$moment().unix()}.wav`
          );
        }

        a.correct_answers.forEach((x) =>
          formDataD.append("correct_answers", x)
        );
        customMaterialService.createDictation(formDataD).then((data) => {
          if (!this.question.dictation_audios) {
            this.question.dictation_audios = [];
          }
          this.question.dictation_audios.push(data);
        });
      });
      optionsMultimedia.forEach((o) => {
        let formData = new FormData();
        formData.append("question", this.question.id);
        formData.append("index", o.index);
        if (o.image) {
          formData.append("image", o.image);
        }
        if (o.audio) {
          if (o.audio instanceof Blob) {
            formData.append(
              "audio",
              o.audio,
              `audio-${this.$moment().unix()}.wav`
            );
          } else {
            let audio_url = new URL(o.audio);
            let audio_name = audio_url.pathname.split("/").pop();
            formData.append("audio", audio_name);
          }
        }
        customMaterialService.optionFiles(formData);
      });

      // Handle matrix images upload to set_of_images field
      if (matrixImages && matrixImages.length > 0) {
        let formData = new FormData();
        formData.append("question", this.question.id);
        matrixImages.forEach((image) => {
          formData.append("matrix_images", image);
        });
        customMaterialService.uploadFiles(formData);
      }

      // Handle set_of_images upload for open questions
      if (setOfImages && setOfImages.length > 0) {
        let formData = new FormData();
        formData.append("question", this.question.id);
        setOfImages.forEach((image) => {
          formData.append("set_of_images", image);
        });
        customMaterialService.uploadFiles(formData).then(() => {
          // Clear the stored files after successful upload
          // Note: blob URLs are kept for display until question is reloaded with server URLs
          if (this.question.set_of_images_files) {
            this.question.set_of_images_files = [];
          }
        });
      }
    },
    saveInstructions(a) {
      let formData = new FormData();
      formData.append("question", this.question.id);

      if (a.del) {
        formData.append("delete", true);
      }
      if (a.temp_img) {
        formData.append("image", a.temp_img);
      }
      if (a.temp_audio) {
        formData.append(
          "audio",
          a.temp_audio,
          `audio-${this.$moment().unix()}.wav`
        );
      }
      formData.append("instruction", a.instruction);
      a.formulas.forEach((f) => {
        formData.append("formulas", f);
      });
      customMaterialService.saveAdditionalInstruction(formData);
    },
    getRelatives() {
      if (this.waitingFamily) {
        if (this.question.count_relatives > 1) {
          customMaterialService.getFamily(this.question.family).then((data) => {
            this.waitingFamily = false;
            this.relatives = data.questions;
          });
        } else {
          this.waitingFamily = false;
        }
      }
    },
    setTag(tag) {
      console.log("set tag");
      this.question.tag = tag;
    },
    setSubtag(subtag) {
      console.log("set subtag");
      this.question.subtags = subtag;
    },
    openRelatedMaterials() {
      this.$refs["related-materials-sidebar"].openFromQuestion();
    },
    openRelatedMaterial(materialID) {
      this.$emit("open-related-material", materialID);
    },
    // Writing question methods
    ensureWritingDefaults() {
      if (this.question.kind !== 11) return;
      if (!this.question.writing_config) {
        this.$set(this.question, 'writing_config', {
          exercise_type: 'traces',
          traces: [],
          traces_visual: {
            lineColor: '#C48178',
            lineWidth: 10,
            tunnelWidth: 14,
            boxHeight: 120,
            iconSize: 40
          },
          caligraphy: {
            type: 'letters',
            content: [],
            fontSize: 36,
            showGuides: true
          }
        });
      }
    },
    onWritingTypeChange() {
      // Reset content when switching between traces and caligraphy
      if (this.question.writing_config.exercise_type === 'traces') {
        this.question.writing_config.traces = [];
      } else {
        this.question.writing_config.caligraphy.content = [];
      }
    },
    addTraceExercise() {
      if (!this.question.writing_config.traces) {
        this.$set(this.question.writing_config, 'traces', []);
      }
      const newId = this.question.writing_config.traces.length + 1;
      this.question.writing_config.traces.push({
        id: newId,
        type: 'wave',
        startIcon: '🦋',
        endIcon: '🏠'
      });
    },
    removeTraceExercise(index) {
      this.question.writing_config.traces.splice(index, 1);
    },
    updateTraceExercise(index, field, value) {
      this.$set(this.question.writing_config.traces[index], field, value);
    },
    onCaligraphyTypeChange() {
      // Reset content when changing caligraphy type
      this.question.writing_config.caligraphy.content = [];
      if (this.question.writing_config.caligraphy.type === 'letters') {
        // Initialize with some default letters
        this.question.writing_config.caligraphy.content = ['a', 'b', 'c'];
      }
    },
    toggleCaligraphyLetter(letter) {
      const content = this.question.writing_config.caligraphy.content;
      const index = content.indexOf(letter);
      if (index > -1) {
        content.splice(index, 1);
      } else {
        content.push(letter);
      }
    },
    addCaligraphyInput() {
      this.question.writing_config.caligraphy.content.push('');
    },
    removeCaligraphyInput(index) {
      this.question.writing_config.caligraphy.content.splice(index, 1);
    },
    getCaligraphyTypeLabel() {
      const type = this.question.writing_config.caligraphy.type;
      const labels = {
        'letters': 'Letras',
        'syllables': 'Sílabas',
        'words': 'Palabras',
        'sentences': 'Frases'
      };
      return labels[type] || 'Elementos';
    },
    getCaligraphyPlaceholder() {
      const type = this.question.writing_config.caligraphy.type;
      const placeholders = {
        'letters': 'Ej: a',
        'syllables': 'Ej: ma',
        'words': 'Ej: casa',
        'sentences': 'Ej: El gato come'
      };
      return placeholders[type] || 'Ejemplo';
    },
    generateTraceSVG(trace) {
      // This will be implemented to generate SVG paths
      // For now, return a placeholder
      return `<svg width="550" height="120"><text x="275" y="60" text-anchor="middle">${trace.type} trace</text></svg>`;
    },
    renderWritingPreview() {
      // This will render the preview of writing exercises
      // Implementation will be added later
    },
    // Fluidez lectora: sin las frases del texto, el PDF sale sin el protocolo
    // de lectura y nadie se entera. Si nadie apretó «Analizar Texto», se
    // analiza al guardar; si no se puede, no se guarda.
    readingEvaluationReady() {
      if (this.hasReadingPhrases) return true;
      if (this.loadingText) {
        this.$toasted.error("Espera a que cargue el texto de la página");
        return false;
      }
      if (!this.readingEvaluationText.trim()) {
        this.$toasted.error("Una pregunta de Evaluación de Lectura necesita el texto de la página: agrégale un texto a la página antes de guardarla");
        return false;
      }
      return this.analyzeReadingText({ alGuardar: true });
    },
    analyzeReadingText({ alGuardar = false } = {}) {
      // Get text from page
      const texto = this.readingEvaluationText.trim();
      // El curso guardado en la pregunta, o el del material si no tiene
      const cursoSeleccionado = this.readingEvaluationCourse;
      
      if (!texto) {
        this.$bvToast.toast('El texto de la página no está disponible. Asegúrate de que la página tenga un texto asociado.', {
          title: 'Error',
          variant: 'danger',
          solid: true
        });
        return false;
      }
      
      if (!cursoSeleccionado) {
        this.$bvToast.toast('El curso no está disponible. Asegúrate de que el material tenga un curso/grade asignado.', {
          title: 'Error',
          variant: 'danger',
          solid: true
        });
        return false;
      }
      
      // Remover "Inicio" y "Fin" (case insensitive)
      let textoLimpio = texto.replace(/\bInicio\b/gi, '').replace(/\bFin\b/gi, '');
      
      // Separar en frases usando . ! ? pero NO puntos suspensivos
      // Primero protegemos los puntos suspensivos
      textoLimpio = textoLimpio.replace(/\.\.\./g, '___PUNTOS_SUSPENSIVOS___');
      
      // Ahora separamos por . ! ?
      const frases = textoLimpio.split(/[.!?]+/).filter(f => f.trim().length > 0);
      
      // Restauramos los puntos suspensivos en cada frase
      const frasesRestauradas = frases.map(f => f.replace(/___PUNTOS_SUSPENSIVOS___/g, '...').trim());
      
      let totalPalabrasSinPuntuacion = 0;
      
      const datosFrases = frasesRestauradas.map((frase, index) => {
        // Palabras SIN puntuación (removemos todos los signos de puntuación y guiones largos/cortos)
        const palabrasSinPuntuacion = frase.replace(/[.,;:!?¡¿\-—–"""''()]/g, ' ')
          .split(/\s+/)
          .filter(p => p.length > 0).length;
        
        totalPalabrasSinPuntuacion += palabrasSinPuntuacion;
        
        // Contar signos de puntuación y expresión
        const puntuacion = (frase.match(/[.,;]/g) || []).length;
        const expresion = (frase.match(/[¡!¿?]/g) || []).length;
        
        return {
          numero: index + 1,
          frase: frase,
          palabrasSinPuntuacion: palabrasSinPuntuacion,
          acumuladoSinPuntuacion: 0, // Se calculará después
          puntuacion: puntuacion,
          expresion: expresion,
          decodificacion: 0 // Errores de decodificación (editable)
        };
      });
      
      // Calcular acumulados
      let acumulado = 0;
      datosFrases.forEach(dato => {
        acumulado += dato.palabrasSinPuntuacion;
        dato.acumuladoSinPuntuacion = acumulado;
      });
      
      // Guardar en reading_evaluation_data (no guardamos el texto completo, solo el análisis)
      this.$set(this.question.reading_evaluation_data, 'phrases', datosFrases);
      this.$set(this.question.reading_evaluation_data, 'total_words', totalPalabrasSinPuntuacion);
      // Volver a analizar no le cambia la rúbrica extra a quien ya la eligió
      this.$set(this.question.reading_evaluation_data, 'show_extra_rubric', !!this.question.reading_evaluation_data.show_extra_rubric);
      this.$set(this.question.reading_evaluation_data, 'course', cursoSeleccionado);
      
      this.$bvToast.toast(`${alGuardar ? 'Se analizó al guardar' : 'Texto analizado'}: ${datosFrases.length} frases, ${totalPalabrasSinPuntuacion} palabras`, {
        title: 'Análisis completado',
        variant: 'success',
        solid: true
      });
      return true;
    },
    updateDecodificacion(phrase, event) {
      // Ensure the value is saved in the question data
      const value = parseInt(event.target.value) || 0;
      const index = this.question.reading_evaluation_data.phrases.findIndex(p => p.numero === phrase.numero);
      if (index !== -1) {
        this.$set(this.question.reading_evaluation_data.phrases[index], 'decodificacion', value);
      }
    }
  },
};
</script>

<style>
.image-section {
  width: 40%;
  max-width: 75%;
  align-items: center;
}
.audio-section {
  width: 70%;
  max-width: 75%;
}
.question-form {
  width: 100%;
  border: #f8b500 1px solid;
  padding-bottom: 5em !important;
  margin: 0.5em auto !important;
}
.modal-image {
  text-align: center;
}
.alternative {
  background-color: rgb(243, 243, 243);
  border-radius: 5px;
  padding: 1em;
  min-height: 3em;
  width: 60%;
}
.alt_correct {
  border-color: rgb(105, 226, 105);
  border-style: dashed;
  border-width: thin;
}
.alt_incorrect {
  border-color: rgb(236, 65, 65);
  border-style: dashed;
  border-width: thin;
}
/* Writing question styles */
.letter-grid {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 5px;
  margin-top: 10px;
}
.letter-btn {
  padding: 8px;
  border: 2px solid #e9ecef;
  background: #fff;
  border-radius: 5px;
  cursor: pointer;
  text-align: center;
  font-size: 16px;
  font-weight: 700;
  transition: all 0.3s;
}
.letter-btn:hover {
  border-color: #3498db;
}
.letter-btn.selected {
  background: #3498db;
  color: #fff;
}
.word-input-group {
  display: flex;
  gap: 10px;
  margin-bottom: 10px;
}
.exercise-item {
  background: #f9fafb;
  padding: 15px;
  border-radius: 8px;
  margin-bottom: 15px;
  display: flex;
  gap: 10px;
  align-items: center;
  flex-wrap: wrap;
}
/* Writing preview styles */
.trace-preview-box {
  background: #f8f9fa;
  border: 2px solid #dee2e6;
}
.trace-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 60px;
  height: 60px;
  background: #fff;
  border-radius: 8px;
  border: 2px solid #e9ecef;
}
.trace-svg {
  min-height: 60px;
  display: flex;
  align-items: center;
}
.caligraphy-preview-box {
  background: #f8f9fa;
  border: 2px solid #dee2e6;
}
.caligraphy-exercise {
  width: 100%;
}
.exercise-header {
  color: #3498db;
  font-weight: 700;
  font-size: 18px;
}
.exercise-steps {
  margin-top: 15px;
}
.step-box {
  border: 2px solid #bdc3c7;
  border-radius: 8px;
  padding: 15px;
  min-height: 100px;
  position: relative;
}
.step-label {
  position: absolute;
  top: -12px;
  left: 10px;
  background: #fff;
  padding: 2px 8px;
  font-size: 11px;
  font-weight: 700;
  border-radius: 4px;
}
.step-model .step-label {
  color: #27ae60;
}
.step-trace .step-label {
  color: #f39c12;
}
.step-practice .step-label {
  color: #e74c3c;
}
.text-model {
  font-family: 'Brush Script MT', cursive;
  text-align: center;
  padding-top: 20px;
  color: #2c3e50;
}
.text-dotted {
  font-family: 'Brush Script MT', cursive;
  text-align: center;
  padding-top: 20px;
  color: transparent;
  -webkit-text-stroke: 1px #999;
}
.guide-line {
  border-top: 1px dashed #ddd;
  margin: 0 10px;
}
.practice-space {
  background: transparent;
}
.essay_question {
  background-color: rgb(243, 243, 243);
  border-radius: 5px;
  width: 80%;
  height: 80px;
  padding: 10px 10px 25px 10px;
}

.dictation_question {
  background-color: rgb(243, 243, 243);
  border-radius: 5px;
  height: 50px;
  padding: 10px 10px 25px 10px;
}

/* Search question styles */
.search-grid-preview {
  display: flex;
  justify-content: center;
  margin: 20px 0;
}

.search-grid {
  display: grid;
  gap: 2px;
  border: 2px solid #ccc;
  padding: 5px;
  background-color: #f9f9f9;
}

.search-grid-cell {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: white;
  border: 1px solid #ddd;
  font-size: 18px;
  font-weight: bold;
}

/* Symbol checkbox group responsive layout */
.symbol-checkbox-group {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: flex-start;
  align-items: center;
}

.symbol-checkbox-group .btn {
  margin: 0;
  flex-shrink: 0;
  flex-grow: 0;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  padding: 0;
  max-width: 40px;
}

.correct-option {
  background-color: rgb(243, 243, 243);
  margin: 1em 0 1em 0;
  border-radius: 5px;
  padding: 1em;
  min-height: 3em;
  max-height: 1000px;
  border-color: rgb(105, 226, 105);
  border-style: dashed;
  border-width: thin;
}
.incorrect-option {
  background-color: rgb(243, 243, 243);
  margin: 1em 0 1em 0;
  border-radius: 5px;
  padding: 1em;
  min-height: 3em;
  max-height: 1000px;
  border-color: rgb(236, 65, 65);
  border-style: dashed;
  border-width: thin;
}

.creating,
.selecting {
  max-height: 500px;
  overflow-y: auto;
  overflow-x: hidden;
}
.modal-footer {
  justify-content: center !important;
}

.formula:hover > .formula-on,
.formula > .formula-off {
  display: none;
}
.formula:hover > .formula-off {
  display: inline;
}
.custom-button {
  min-width: 120px;
}
.custom-dots-button {
  background-color: #00b9ae !important;
}

/* Grid builder */
.grid-builder {
  margin: 8px 12px;
}
.grid-cell {
  background-color: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  user-select: none;
  background-size: cover;
  background-position: center;
  position: relative;
}
.grid-cell:hover {
  border-color: #00b9ae;
}
.grid-cell-number {
  font-weight: 700;
  color: rgba(0,0,0,0.85);
  text-shadow: 0 1px 2px rgba(255,255,255,0.7);
  background: rgba(255,255,255,0.55);
  border-radius: 10px;
  padding: 2px 6px;
}
.piece-tooltip {
  position: absolute;
  bottom: calc(100% + 2px);
  left: 50%;
  transform: translateX(-50%);
  display: grid;
  grid-template-columns: repeat(6, 24px);
  gap: 4px;
  padding: 4px;
  background: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
  z-index: 10;
}
.piece-option {
  width: 24px;
  height: 24px;
  border-radius: 3px;
  border: 1px solid #cfcfcf;
  background-size: cover;
  background-position: center;
  cursor: pointer;
}
.piece-option:hover {
  border-color: #00b9ae;
  transform: scale(1.1);
}
.piece-option.empty {
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  color: #666;
  background: #f4f4f4;
}
/* Puzzle (kind 5) */
.puzzle-target {
  width: 180px;
  height: 180px;
  border: 2px dashed #00b9ae;
  border-radius: 6px;
  background: #f9fbfb;
  cursor: pointer;
}
.piece-card {
  position: relative;
  border: 1px solid #e0e0e0;
  background: #ffffff;
  border-radius: 6px;
  min-height: 130px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.piece-badge {
  position: absolute;
  top: 6px;
  left: 6px;
  background: #343a40;
  color: #fff;
  border-radius: 8px;
  font-size: 11px;
  padding: 2px 6px;
}
.piece-image {
  max-height: 110px;
}
.piece-placeholder {
  color: #888;
}
.selection-row {
  background: #eaf7f6;
  border: 1px solid #d3efed;
  border-radius: 6px;
  padding: 10px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

/* Matrix (kind 7) */
.matrix-container {
  border: 2px solid #000;
  border-radius: 8px;
  padding: 8px;
  background: #fff;
}

.matrix-cell {
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  min-height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
  transition: all 0.2s ease;
}

.matrix-cell:hover {
  border-color: #00b9ae;
  background: #f9fbfb;
}

.matrix-cell.question-mark-cell {
  background: #ffb3d1;
  border-color: #ff69b4;
}

.matrix-image-container {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.matrix-image-container img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.question-mark {
  font-size: 48px;
  font-weight: bold;
  color: #333;
}

.matrix-placeholder {
  color: #888;
  font-size: 12px;
  text-align: center;
}

.answer-options-container {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  max-width: 800px;
}

.answer-option {
  position: relative;
  width: 80px;
  height: 80px;
  background: #e6e6fa;
  border: 2px solid #9370db;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
}

.answer-option:hover {
  border-color: #00b9ae;
  background: #f0f8ff;
  transform: scale(1.05);
}

.answer-image-container {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.answer-image-container img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.answer-placeholder {
  color: #666;
  font-size: 10px;
  text-align: center;
}

.answer-number {
  position: absolute;
  bottom: 4px;
  right: 4px;
  background: #333;
  color: #fff;
  border-radius: 10px;
  font-size: 10px;
  padding: 2px 6px;
  min-width: 16px;
  text-align: center;
}

.answer-option.correct-answer {
  border-color: #28a745;
  background: #d4edda;
  box-shadow: 0 0 0 2px rgba(40, 167, 69, 0.25);
}

/* VISUAL KEY styles */
.vk-keys-container { margin: 16px 0; padding: 12px; border-radius: 10px; background: linear-gradient(90deg, #dbeafe, #c7d2fe); border: 2px solid #6366f1; overflow: hidden; }
.vk-keys-title {
  text-align: center;
  font-weight: 700;
  font-size: 18px;
  margin-bottom: 10px;
}
.vk-keys { display: grid; grid-template-columns: repeat(9, 1fr); gap: 8px; align-items: stretch; }
.vk-key { background: #fff; border: 2px solid #2f3640; border-radius: 4px; display: flex; flex-direction: column; align-items: center; justify-content: center; min-height: 80px; }
.vk-key-number { font-weight: 800; color: #1f2937; }
.vk-key-symbol { color: #6366f1; font-size: 26px; font-weight: 700; }

.vk-grid-container { margin-top: 18px; padding: 12px; border-radius: 10px; background: #e8f7ef; border: 2px solid #10b981; }
.vk-grid-title { text-align: center; font-weight: 700; font-size: 18px; margin-bottom: 10px; }
.vk-grid { display: grid; gap: 8px; }
.vk-cell { background: #fff; border: 2px solid #2f3640; border-radius: 4px; padding: 8px; }
.vk-cell-number { font-weight: 700; color: #111827; margin-bottom: 8px; }
.vk-cell-draw { height: 38px; border: 2px dashed #9ca3af; border-radius: 6px; background: #ffffff; }

/* Reading Evaluation Table Styles */
.reading-evaluation-table-container {
  margin-top: 20px;
}

.reading-evaluation-table {
  width: 100%;
  border-collapse: collapse;
  background: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.reading-evaluation-table thead {
  background: linear-gradient(90deg, #6b46c1 0%, #8b5cf6 50%, #a78bfa 100%);
}

.reading-evaluation-table th {
  padding: 12px 8px;
  color: white;
  font-weight: 600;
  font-size: 14px;
  border: none;
}

.reading-evaluation-table tbody tr {
  border-bottom: 1px solid #e5e7eb;
}

.reading-evaluation-table tbody tr:last-child {
  border-bottom: none;
}

.reading-evaluation-table td {
  padding: 12px 8px;
  font-size: 14px;
  color: #1f2937;
}

.reading-evaluation-table .numeric-value {
  color: #2563eb;
  font-weight: 600;
}

.reading-evaluation-table .phrase-text {
  color: #1f2937;
  max-width: 400px;
  word-wrap: break-word;
}

.decodificacion-input {
  width: 60px;
  padding: 6px 8px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  background: #f9fafb;
  text-align: center;
  font-size: 14px;
  font-weight: 600;
  color: #2563eb;
}

.decodificacion-input:focus {
  outline: none;
  border-color: #8b5cf6;
  background: white;
  box-shadow: 0 0 0 3px rgba(139, 92, 246, 0.1);
}

.download-protocol-btn {
  background: linear-gradient(90deg, #6b46c1 0%, #8b5cf6 50%, #a78bfa 100%);
  border: none;
  border-radius: 8px;
  padding: 12px 24px;
  font-weight: 600;
  font-size: 16px;
  color: white;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(107, 70, 193, 0.3);
}

.download-protocol-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(107, 70, 193, 0.4);
  background: linear-gradient(90deg, #7c3aed 0%, #9d6af7 50%, #b794f6 100%);
}

.download-protocol-btn:active {
  transform: translateY(0);
}

.download-icon {
  display: inline-block;
  margin-right: 8px;
  font-size: 18px;
  font-weight: 300;
}
</style>
<style scoped>
::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}
::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.3);
  -webkit-border-radius: 5px;
  border-radius: 5px;
}
::-webkit-scrollbar-thumb {
  -webkit-border-radius: 5px;
  border-radius: 5px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.5);
}
.cursor-pointer {
  cursor: pointer;
}
.scrollable-radio-group {
  overflow-x: auto;
  overflow-y: hidden;
}
.scrollable-radio-group ::v-deep .btn-group {
  flex-wrap: nowrap;
  white-space: nowrap;
}
</style>

<style>
.ML__keyboard {
  z-index: 1060 !important;
}
</style>

